/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "integrations/db/models.proto" (package "rd.integrations", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { IntegrationVendor } from "../../proto/integration_vendor/models_pb";
import { FractionalMoney } from "../../proto/money/models_pb";
import { Money } from "../../proto/money/models_pb";
import { Decimal } from "../../proto/decimal/models_pb";
import { Address } from "../../proto/address/models_pb";
import { FunctionalIdentifierCode } from "../x12/models_pb";
import { AcknowledgeCode } from "../x12/models_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { UUID } from "../../proto/uuid/models_pb";
/**
 * @generated from protobuf message rd.integrations.Message
 */
export interface Message {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * Should be the same as created_at (except for exceptions?)
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string sender_id = 5
     */
    senderId: string;
    /**
     * @generated from protobuf field: string receiver_id = 6
     */
    receiverId: string;
    /**
     * @generated from protobuf field: int32 control_number = 7
     */
    controlNumber: number;
    /**
     * This is the time of the message, not the time of the log
     * but they should be very close
     *
     * @generated from protobuf field: google.protobuf.Timestamp time = 8
     */
    time?: Timestamp;
    /**
     * @generated from protobuf field: string address = 9
     */
    address: string;
    /**
     * @generated from protobuf field: string username = 10
     */
    username: string;
    /**
     * @generated from protobuf field: string sftp_path = 11
     */
    sftpPath: string;
    /**
     * @generated from protobuf field: string gcs_object_name = 12
     */
    gcsObjectName: string;
    /**
     * @generated from protobuf field: rd.integrations.MessageStatus status = 13
     */
    status: MessageStatus;
    /**
     * This is the error message from the uploader for the outgoing message
     * This is the parser error message for the incoming message
     *
     * @generated from protobuf field: string error_message = 14
     */
    errorMessage: string;
    /**
     * General purpose field for any comments
     *
     * @generated from protobuf field: string comments = 15
     */
    comments: string;
}
/**
 * @generated from protobuf message rd.integrations.AckData
 */
export interface AckData {
    /**
     * @generated from protobuf field: rd.integrations.x12.AcknowledgeCode acknowledge_code = 1
     */
    acknowledgeCode: AcknowledgeCode;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID ack_group_id = 2
     */
    ackGroupId?: UUID;
    /**
     * @generated from protobuf field: int32 number_of_received_transaction_sets = 3
     */
    numberOfReceivedTransactionSets: number;
    /**
     * @generated from protobuf field: int32 number_of_accepted_transaction_sets = 4
     */
    numberOfAcceptedTransactionSets: number;
    /**
     * @generated from protobuf field: int32 number_of_rejected_transaction_sets = 5
     */
    numberOfRejectedTransactionSets: number;
}
/**
 * @generated from protobuf message rd.integrations.ShipmentData
 */
export interface ShipmentData {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID shipment_message_log_id = 1
     */
    shipmentMessageLogId?: UUID;
    /**
     * @generated from protobuf field: string hierarchical_id = 2
     */
    hierarchicalId: string;
    /**
     * @generated from protobuf field: string po_identifier = 3
     */
    poIdentifier: string;
    /**
     * @generated from protobuf field: string date = 4
     */
    date: string;
}
// message InvoiceData {}

/**
 * @generated from protobuf message rd.integrations.Group
 */
export interface Group {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.integrations.x12.FunctionalIdentifierCode functional_identifier_code = 5
     */
    functionalIdentifierCode: FunctionalIdentifierCode;
    /**
     * @generated from protobuf field: string application_sender_code = 6
     */
    applicationSenderCode: string;
    /**
     * @generated from protobuf field: string application_receiver_code = 7
     */
    applicationReceiverCode: string;
    /**
     * @generated from protobuf field: int32 control_number = 8
     */
    controlNumber: number;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID message_id = 9
     */
    messageId?: UUID;
    /**
     * Just for PO groups
     *
     * @generated from protobuf field: rd.integrations.AckData ack_data = 10
     */
    ackData?: AckData; // ShipmentData shipment_data = 11;
    // InvoiceData invoice_data = 12;
    /**
     * @generated from protobuf field: string comments = 13
     */
    comments: string;
}
// message ShipmetOrder {}

/**
 * @generated from protobuf message rd.integrations.Order
 */
export interface Order {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string identifier = 4
     */
    identifier: string;
    /**
     * @generated from protobuf field: int32 control_number = 5
     */
    controlNumber: number;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID group_id = 6
     */
    groupId?: UUID;
    /**
     * @generated from protobuf field: int32 group_control_number = 7
     */
    groupControlNumber: number;
    /**
     * @generated from protobuf field: rd.integrations.x12.AcknowledgeCode acknowledge_code = 8
     */
    acknowledgeCode: AcknowledgeCode; // ShipmetOrder shipment_order = 9;
    /**
     * @generated from protobuf field: string comments = 10
     */
    comments: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID txn_order_id = 11
     */
    txnOrderId?: UUID;
}
/**
 * @generated from protobuf message rd.integrations.MessageControlNumber
 */
export interface MessageControlNumber {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string sender = 4
     */
    sender: string; // In case one day we decide to have multiple senders
    /**
     * @generated from protobuf field: string receiver = 5
     */
    receiver: string;
    /**
     * @generated from protobuf field: int32 control_number = 6
     */
    controlNumber: number;
}
/**
 * @generated from protobuf message rd.integrations.GroupControlNumber
 */
export interface GroupControlNumber {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.integrations.x12.FunctionalIdentifierCode functional_identifier_code = 4
     */
    functionalIdentifierCode: FunctionalIdentifierCode;
    /**
     * @generated from protobuf field: string sender = 5
     */
    sender: string;
    /**
     * @generated from protobuf field: string receiver = 6
     */
    receiver: string;
    /**
     * @generated from protobuf field: int32 control_number = 7
     */
    controlNumber: number;
}
/**
 * @generated from protobuf message rd.integrations.ShipmentNotification
 */
export interface ShipmentNotification {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string sender_id = 4
     */
    senderId: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 5
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_id = 6
     */
    orderId?: UUID;
    /**
     * @generated from protobuf field: int32 total_shipped = 7
     */
    totalShipped: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp shipped_at = 8
     */
    shippedAt?: Timestamp;
    /**
     * @generated from protobuf field: string notes = 9
     */
    notes: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 10
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string identifier = 11
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 12
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.address.Address shipment_address = 13
     */
    shipmentAddress?: Address;
    /**
     * @generated from protobuf field: string shipment_to = 14
     */
    shipmentTo: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID edi_message_id = 15
     */
    ediMessageId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.integrations.ShipmentNotification.Product products = 16
     */
    products: ShipmentNotification_Product[];
    /**
     * @generated from protobuf field: rd.integrations.ShipmentNotification.Status status = 17
     */
    status: ShipmentNotification_Status;
}
/**
 * @generated from protobuf message rd.integrations.ShipmentNotification.Product
 */
export interface ShipmentNotification_Product {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 1
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: int32 quantity_shipped = 2
     */
    quantityShipped: number;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal cost = 3
     */
    cost?: Decimal;
    /**
     * @generated from protobuf field: string unit_of_measurement = 4
     */
    unitOfMeasurement: string;
    /**
     * @generated from protobuf field: int32 quantity_ordered = 5
     */
    quantityOrdered: number;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal retail_price = 6
     */
    retailPrice?: Decimal;
    /**
     * @generated from protobuf field: string sku = 7
     */
    sku: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_shipped_v2 = 8
     */
    quantityShippedV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_ordered_v2 = 9
     */
    quantityOrderedV2?: Decimal;
}
/**
 * @generated from protobuf enum rd.integrations.ShipmentNotification.Status
 */
export enum ShipmentNotification_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_RECEIVED = 1;
     */
    RECEIVED = 1
}
/**
 * @generated from protobuf message rd.integrations.PriceChange
 */
export interface PriceChange {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string sender_id = 4
     */
    senderId: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 5
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: string gcs_object_name = 6
     */
    gcsObjectName: string;
    /**
     * @generated from protobuf field: string customer_number = 7
     */
    customerNumber: string;
    /**
     * @generated from protobuf field: string sku = 8
     */
    sku: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp effective_date = 9
     */
    effectiveDate?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money vendor_retail = 11
     */
    vendorRetail?: Money;
    /**
     * @generated from protobuf field: string unit = 12
     */
    unit: string;
    /**
     * @generated from protobuf field: string upc = 13
     */
    upc: string;
    /**
     * @generated from protobuf field: string retail_class = 14
     */
    retailClass: string;
    /**
     * @generated from protobuf field: bool promotional = 15
     */
    promotional: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney vendor_cost_v2 = 16
     */
    vendorCostV2?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 17
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 18
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.integrations.PriceChange.Status status = 19
     */
    status: PriceChange_Status;
    /**
     * @generated from protobuf field: rd.proto.integration_vendor.IntegrationVendor integration_vendor = 20
     */
    integrationVendor: IntegrationVendor;
    /**
     * @generated from protobuf field: rd.integrations.PriceChange.DoItBestPriceChange do_it_best_price_change = 21
     */
    doItBestPriceChange?: PriceChange_DoItBestPriceChange;
    /**
     * @generated from protobuf field: string sale_code = 22
     */
    saleCode: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sale_starts_at = 23
     */
    saleStartsAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sale_ends_at = 24
     */
    saleEndsAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.integrations.PriceChange.DoItBestPriceChange
 */
export interface PriceChange_DoItBestPriceChange {
    /**
     * @generated from protobuf field: string record_code = 1
     */
    recordCode: string;
    /**
     * @generated from protobuf field: string member_number = 2
     */
    memberNumber: string;
    /**
     * @generated from protobuf field: string sku = 3
     */
    sku: string;
    /**
     * @generated from protobuf field: string product_code = 4
     */
    productCode: string;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney item_price_change = 5
     */
    itemPriceChange?: FractionalMoney;
    /**
     * @generated from protobuf field: string unit_of_measure = 6
     */
    unitOfMeasure: string;
    /**
     * @generated from protobuf field: string item_type = 7
     */
    itemType: string;
    /**
     * @generated from protobuf field: string price_status_code = 8
     */
    priceStatusCode: string;
    /**
     * @generated from protobuf field: string effective_date = 9
     */
    effectiveDate: string;
    /**
     * @generated from protobuf field: string promo_status_code = 10
     */
    promoStatusCode: string;
    /**
     * @generated from protobuf field: string reorder_start_date = 11
     */
    reorderStartDate: string;
    /**
     * @generated from protobuf field: string reorder_end_date = 12
     */
    reorderEndDate: string;
    /**
     * @generated from protobuf field: string sale_start_date = 13
     */
    saleStartDate: string;
    /**
     * @generated from protobuf field: string sale_code = 14
     */
    saleCode: string;
    /**
     * @generated from protobuf field: string sale_end_date = 15
     */
    saleEndDate: string;
    /**
     * @generated from protobuf field: string member_cost_option = 16
     */
    memberCostOption: string;
    /**
     * @generated from protobuf field: int32 mult_3 = 17
     */
    mult3: number;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_3 = 18
     */
    cost3?: FractionalMoney;
    /**
     * @generated from protobuf field: int32 mult_2 = 19
     */
    mult2: number;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_2 = 20
     */
    cost2?: FractionalMoney;
    /**
     * @generated from protobuf field: int32 mult_1 = 21
     */
    mult1: number;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_1 = 22
     */
    cost1?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.Money member_retail = 23
     */
    memberRetail?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal gross_margin = 24
     */
    grossMargin?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money suggested_retail = 25
     */
    suggestedRetail?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money suggested_aux_retail = 26
     */
    suggestedAuxRetail?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal suggested_margin = 27
     */
    suggestedMargin?: Decimal;
    /**
     * @generated from protobuf field: int32 do_it_best_corp_use = 28
     */
    doItBestCorpUse: number;
    /**
     * @generated from protobuf field: string mbr_aux_retail_switch = 29
     */
    mbrAuxRetailSwitch: string;
    /**
     * @generated from protobuf field: string aux_unit = 30
     */
    auxUnit: string;
    /**
     * @generated from protobuf field: int32 aux_qty = 31
     */
    auxQty: number;
    /**
     * @generated from protobuf field: string status_code = 32
     */
    statusCode: string;
    /**
     * @generated from protobuf field: string personal_sku = 33
     */
    personalSku: string;
}
/**
 * @generated from protobuf enum rd.integrations.PriceChange.Status
 */
export enum PriceChange_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_PROCESSED = 1;
     */
    PROCESSED = 1,
    /**
     * @generated from protobuf enum value: STATUS_CANCELLED = 2;
     */
    CANCELLED = 2
}
/**
 * @generated from protobuf message rd.integrations.ProcessedFile
 */
export interface ProcessedFile {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string sender_id = 2
     */
    senderId: string;
    /**
     * @generated from protobuf field: string file_name = 3
     */
    fileName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp processed_at = 4
     */
    processedAt?: Timestamp;
    /**
     * @generated from protobuf field: string content_hash = 5
     */
    contentHash: string;
}
/**
 * @generated from protobuf message rd.integrations.InvoiceItemData
 */
export interface InvoiceItemData {
    /**
     * @generated from protobuf field: string assigned_identification = 1
     */
    assignedIdentification: string; // This is the id in the PO
    /**
     * @generated from protobuf field: string quantity_invoiced = 2
     */
    quantityInvoiced: string;
    /**
     * @generated from protobuf field: string unit_of_measurement = 3
     */
    unitOfMeasurement: string;
    /**
     * @generated from protobuf field: string unit_price = 4
     */
    unitPrice: string;
    /**
     * @generated from protobuf field: string product_name = 5
     */
    productName: string;
    /**
     * @generated from protobuf field: string product_id = 6
     */
    productId: string;
    /**
     * @generated from protobuf field: string description = 7
     */
    description: string;
}
/**
 * @generated from protobuf message rd.integrations.Invoice
 */
export interface Invoice {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string sender_id = 4
     */
    senderId: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 5
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_id = 6
     */
    orderId?: UUID;
    /**
     * X12 Invoice fields from x12/invoice.go
     *
     * @generated from protobuf field: string invoice_date = 7
     */
    invoiceDate: string;
    /**
     * @generated from protobuf field: string invoice_number = 8
     */
    invoiceNumber: string;
    /**
     * @generated from protobuf field: string po_date = 9
     */
    poDate: string;
    /**
     * @generated from protobuf field: string po_number = 10
     */
    poNumber: string;
    /**
     * @generated from protobuf field: bool debit = 11
     */
    debit: boolean;
    /**
     * @generated from protobuf field: bool charge = 12
     */
    charge: boolean;
    /**
     * @generated from protobuf field: double total_amount = 13
     */
    totalAmount: number;
    /**
     * @generated from protobuf field: double charge_amount = 14
     */
    chargeAmount: number;
    /**
     * @generated from protobuf field: string misc_charge_description = 15
     */
    miscChargeDescription: string;
    /**
     * @generated from protobuf field: string number_of_units_shipped = 16
     */
    numberOfUnitsShipped: string;
    /**
     * @generated from protobuf field: string unit_of_measurement = 17
     */
    unitOfMeasurement: string;
    /**
     * N1 segment data
     *
     * @generated from protobuf field: string name = 18
     */
    name: string;
    /**
     * @generated from protobuf field: string identification_code = 19
     */
    identificationCode: string;
    /**
     * @generated from protobuf field: string order_number = 20
     */
    orderNumber: string;
    /**
     * @generated from protobuf field: string terms_discount_percent = 21
     */
    termsDiscountPercent: string;
    /**
     * @generated from protobuf field: string terms_discount_due_date = 22
     */
    termsDiscountDueDate: string;
    /**
     * @generated from protobuf field: string terms_net_due_date = 23
     */
    termsNetDueDate: string;
    /**
     * @generated from protobuf field: double terms_discount_amount = 24
     */
    termsDiscountAmount: number;
    /**
     * @generated from protobuf field: string terms_description = 25
     */
    termsDescription: string;
    /**
     * @generated from protobuf field: repeated rd.integrations.InvoiceItemData items = 26
     */
    items: InvoiceItemData[];
}
/**
 * @generated from protobuf message rd.integrations.FanBuilderCustomer
 */
export interface FanBuilderCustomer {
    /**
     * @generated from protobuf field: string system_customer_id = 1
     */
    systemCustomerId: string;
    /**
     * String on coupon/create payloads; SendTransaction's POSCustomer uses an int
     * stored here as a decimal (e.g. "1") so both round-trip through this message.
     *
     * @generated from protobuf field: string customer_type = 2
     */
    customerType: string;
    /**
     * @generated from protobuf field: string first_name = 3
     */
    firstName: string;
    /**
     * @generated from protobuf field: string last_name = 4
     */
    lastName: string;
    /**
     * @generated from protobuf field: string employee_id = 5
     */
    employeeId: string;
    /**
     * @generated from protobuf field: string contact_via = 6
     */
    contactVia: string;
    /**
     * @generated from protobuf field: string middle_name = 7
     */
    middleName: string;
    /**
     * @generated from protobuf field: string full_name = 8
     */
    fullName: string;
    /**
     * @generated from protobuf field: string company_name = 9
     */
    companyName: string;
    /**
     * @generated from protobuf field: string address1 = 10
     */
    address1: string;
    /**
     * @generated from protobuf field: string address2 = 11
     */
    address2: string;
    /**
     * @generated from protobuf field: string city = 12
     */
    city: string;
    /**
     * @generated from protobuf field: string state = 13
     */
    state: string;
    /**
     * @generated from protobuf field: string zip = 14
     */
    zip: string;
    /**
     * @generated from protobuf field: string country = 15
     */
    country: string;
    /**
     * @generated from protobuf field: string email = 16
     */
    email: string;
    /**
     * @generated from protobuf field: int32 birth_month = 17
     */
    birthMonth: number;
    /**
     * @generated from protobuf field: string mobile_phone = 18
     */
    mobilePhone: string;
}
/**
 * FanBuilderUseCouponRequest is the structured request payload for Coupon/UseCoupon (for logging).
 *
 * @generated from protobuf message rd.integrations.FanBuilderUseCouponRequest
 */
export interface FanBuilderUseCouponRequest {
    /**
     * @generated from protobuf field: rd.integrations.FanBuilderCustomer customer = 1
     */
    customer?: FanBuilderCustomer;
    /**
     * @generated from protobuf field: double subtotal = 2
     */
    subtotal: number;
    /**
     * @generated from protobuf field: repeated rd.integrations.FanBuilderUseCouponRequest.CouponDetail coupon_details = 3
     */
    couponDetails: FanBuilderUseCouponRequest_CouponDetail[];
}
/**
 * @generated from protobuf message rd.integrations.FanBuilderUseCouponRequest.CouponDetail
 */
export interface FanBuilderUseCouponRequest_CouponDetail {
    /**
     * @generated from protobuf field: string coupon_code = 1
     */
    couponCode: string;
    /**
     * Dollars off. For a percentage coupon this is only known at checkout, so it stays 0 until the
     * sale completes and the rate below is applied to the final cart.
     *
     * @generated from protobuf field: double amount = 2
     */
    amount: number;
    /**
     * @generated from protobuf field: bool taxable = 3
     */
    taxable: boolean;
    /**
     * CES DiscountType: 1 fixed amount, 2 percentage. See loyalty.CouponDiscountType*.
     *
     * @generated from protobuf field: int32 discount_type = 4
     */
    discountType: number;
    /**
     * Fraction of the discountable subtotal for a percentage coupon (0.1 means 10%). Storing the
     * rule rather than a figure is what keeps a coupon from going stale as the cart changes.
     *
     * @generated from protobuf field: double rate = 5
     */
    rate: number;
}
/**
 * FanBuilderUseCouponResponse is the structured response from Coupon/UseCoupon (for logging).
 *
 * @generated from protobuf message rd.integrations.FanBuilderUseCouponResponse
 */
export interface FanBuilderUseCouponResponse {
    /**
     * @generated from protobuf field: string error_flag = 1
     */
    errorFlag: string;
    /**
     * @generated from protobuf field: string error_message = 2
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: string diagnostic_information = 3
     */
    diagnosticInformation: string;
    /**
     * @generated from protobuf field: string token_expired_flag = 4
     */
    tokenExpiredFlag: string;
    /**
     * @generated from protobuf field: repeated rd.integrations.FanBuilderUseCouponResponse.CouponDetail coupon_details = 5
     */
    couponDetails: FanBuilderUseCouponResponse_CouponDetail[];
}
/**
 * @generated from protobuf message rd.integrations.FanBuilderUseCouponResponse.CouponDetail
 */
export interface FanBuilderUseCouponResponse_CouponDetail {
    /**
     * @generated from protobuf field: string coupon_code = 1
     */
    couponCode: string;
    /**
     * @generated from protobuf field: bool valid = 2
     */
    valid: boolean;
    /**
     * @generated from protobuf field: string message = 3
     */
    message: string;
    /**
     * @generated from protobuf field: string description = 4
     */
    description: string;
}
/**
 * FanBuilderUseCouponLog stores the request and response for each Coupon/UseCoupon API call.
 *
 * @generated from protobuf message rd.integrations.FanBuilderUseCouponLog
 */
export interface FanBuilderUseCouponLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string message_id = 4
     */
    messageId: string;
    /**
     * @generated from protobuf field: string system_store_id = 5
     */
    systemStoreId: string;
    /**
     * @generated from protobuf field: string system_customer_id = 6
     */
    systemCustomerId: string;
    /**
     * @generated from protobuf field: rd.integrations.FanBuilderUseCouponRequest request = 7
     */
    request?: FanBuilderUseCouponRequest;
    /**
     * @generated from protobuf field: rd.integrations.FanBuilderUseCouponResponse response = 8
     */
    response?: FanBuilderUseCouponResponse;
    /**
     * TerminalId from the vendor base payload (required for RetryUndeliveredCouponUsages).
     *
     * @generated from protobuf field: string terminal_id = 10
     */
    terminalId: string;
    /**
     * Company that issued the API call (for production CES credentials on retry).
     *
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 11
     */
    companyId?: UUID;
    /**
     * Sale the coupons belong to, when the redemption came from one.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 12
     */
    saleId?: UUID;
    /**
     * The field takes a new number rather than reusing 9: bool and enum share a wire type, so an
     * existing is_delivered = true row would otherwise decode as the first enum value.
     *
     * @generated from protobuf field: rd.integrations.FanBuilderUseCouponLog.Status status = 13
     */
    status: FanBuilderUseCouponLog_Status;
}
/**
 * Status tracks a coupon redemption from the moment it is recorded to CES confirming it. Replaces
 * an is_delivered bool, which could not distinguish a redemption still owed from one refused.
 *
 * @generated from protobuf enum rd.integrations.FanBuilderUseCouponLog.Status
 */
export enum FanBuilderUseCouponLog_Status {
    /**
     * Rows written before this field existed. Never sent, never retried.
     *
     * @generated from protobuf enum value: STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Recorded but deliberately not sent, for a sale that has not been completed. Nothing writes
     * this today: a coupon is only recorded by a sale that completes, so it is born PENDING. The
     * value is kept for a future path that lets an open sale hold a coupon without spending it.
     *
     * @generated from protobuf enum value: STATUS_STAGED = 1;
     */
    STAGED = 1,
    /**
     * Owed to CES and not yet settled: written before the send, so this covers a redemption that
     * has not been attempted as well as one CES has not given a definitive answer to. The cron
     * retries these, which is why the row is complete before it is written.
     *
     * @generated from protobuf enum value: STATUS_PENDING = 2;
     */
    PENDING = 2,
    /**
     * CES gave a definitive answer, success or a business rejection. Never retried again.
     *
     * @generated from protobuf enum value: STATUS_DELIVERED = 3;
     */
    DELIVERED = 3
}
/**
 * FanBuilderTransactionRequest is a lossless replay of SendTransactionRequest.
 * A failed first attempt (checkout or FanBuilderCall with logging on) must be
 * resent with the same body. ReceiptDetails and CardTokens are opaque JSON
 * because the Go types are interface{}.
 *
 * @generated from protobuf message rd.integrations.FanBuilderTransactionRequest
 */
export interface FanBuilderTransactionRequest {
    /**
     * @generated from protobuf field: string transaction_id = 1
     */
    transactionId: string;
    /**
     * @generated from protobuf field: string transaction_date = 2
     */
    transactionDate: string;
    /**
     * @generated from protobuf field: string reference = 3
     */
    reference: string;
    /**
     * Absent for a non-rewards transaction (no customer, or customer not enrolled).
     *
     * @generated from protobuf field: rd.integrations.FanBuilderCustomer customer = 4
     */
    customer?: FanBuilderCustomer;
    /**
     * @generated from protobuf field: double subtotal = 5
     */
    subtotal: number;
    /**
     * @generated from protobuf field: double total_taxable = 6
     */
    totalTaxable: number;
    /**
     * @generated from protobuf field: double total_non_taxable = 7
     */
    totalNonTaxable: number;
    /**
     * @generated from protobuf field: double total_sales_tax = 8
     */
    totalSalesTax: number;
    /**
     * @generated from protobuf field: double total = 9
     */
    total: number;
    /**
     * @generated from protobuf field: repeated rd.integrations.FanBuilderTransactionRequest.Item item_details = 10
     */
    itemDetails: FanBuilderTransactionRequest_Item[];
    /**
     * @generated from protobuf field: string created_by = 11
     */
    createdBy: string;
    /**
     * @generated from protobuf field: bytes receipt_details = 12
     */
    receiptDetails: Uint8Array;
    /**
     * @generated from protobuf field: bytes card_tokens = 13
     */
    cardTokens: Uint8Array;
}
/**
 * @generated from protobuf message rd.integrations.FanBuilderTransactionRequest.Item
 */
export interface FanBuilderTransactionRequest_Item {
    /**
     * @generated from protobuf field: int32 line_number = 1
     */
    lineNumber: number;
    /**
     * @generated from protobuf field: string item_number = 2
     */
    itemNumber: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: double quantity = 4
     */
    quantity: number;
    /**
     * @generated from protobuf field: double price = 5
     */
    price: number;
    /**
     * @generated from protobuf field: double extension = 6
     */
    extension: number;
    /**
     * @generated from protobuf field: string quantity_unit = 7
     */
    quantityUnit: string;
    /**
     * @generated from protobuf field: string price_unit = 8
     */
    priceUnit: string;
    /**
     * @generated from protobuf field: string codes = 9
     */
    codes: string;
    /**
     * @generated from protobuf field: string department = 10
     */
    department: string;
    /**
     * @generated from protobuf field: string upc = 11
     */
    upc: string;
}
/**
 * FanBuilderTransactionResponse is the structured response from Transaction/SendTransaction (for
 * logging).
 *
 * @generated from protobuf message rd.integrations.FanBuilderTransactionResponse
 */
export interface FanBuilderTransactionResponse {
    /**
     * @generated from protobuf field: string error_flag = 1
     */
    errorFlag: string;
    /**
     * @generated from protobuf field: string error_message = 2
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: string diagnostic_information = 3
     */
    diagnosticInformation: string;
    /**
     * @generated from protobuf field: string token_expired_flag = 4
     */
    tokenExpiredFlag: string;
}
/**
 * FanBuilderTransactionLog stores the request and response for each Transaction/SendTransaction
 * call, so a sale whose points never reached CES can be resent by the Fan Builder cron.
 *
 * @generated from protobuf message rd.integrations.FanBuilderTransactionLog
 */
export interface FanBuilderTransactionLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string message_id = 4
     */
    messageId: string;
    /**
     * @generated from protobuf field: string system_store_id = 5
     */
    systemStoreId: string;
    /**
     * TerminalId from the vendor base payload (required for replay).
     *
     * @generated from protobuf field: string terminal_id = 6
     */
    terminalId: string;
    /**
     * Sale the transaction was reported for.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 7
     */
    saleId?: UUID;
    /**
     * Company that issued the API call (for production CES credentials on retry).
     *
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 8
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.integrations.FanBuilderTransactionRequest request = 9
     */
    request?: FanBuilderTransactionRequest;
    /**
     * @generated from protobuf field: rd.integrations.FanBuilderTransactionResponse response = 10
     */
    response?: FanBuilderTransactionResponse;
    /**
     * @generated from protobuf field: bool is_delivered = 11
     */
    isDelivered: boolean;
}
/**
 * @generated from protobuf message rd.integrations.RewardProgramCredentials
 */
export interface RewardProgramCredentials {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.integration_vendor.IntegrationVendor integration_vendor = 5
     */
    integrationVendor: IntegrationVendor;
    /**
     * @generated from protobuf field: string username = 6
     */
    username: string;
    /**
     * @generated from protobuf field: bytes password = 7
     */
    password: Uint8Array;
    /**
     * @generated from protobuf field: string auth_token = 8
     */
    authToken: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp auth_token_acquired_at = 9
     */
    authTokenAcquiredAt?: Timestamp;
}
/**
 * RetailInventorySnapshot is the last values we sent to a vendor's Retail
 * Inventory File for one (company, location, integration vendor, account number, product).
 * The daily upload diffs current state against these rows to decide what to re-send.
 * Unique on (company_id, location_id, integration_vendor, account_number, product_id).
 *
 * @generated from protobuf message rd.integrations.RetailInventorySnapshot
 */
export interface RetailInventorySnapshot {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 5
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string account_number = 6
     */
    accountNumber: string; // used to be rd.proto.uuid.UUID vendor_id
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 7
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.integration_vendor.IntegrationVendor integration_vendor = 8
     */
    integrationVendor: IntegrationVendor;
    /**
     * @generated from protobuf field: string sku = 9
     */
    sku: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_sku_id = 10
     */
    vendorSkuId?: UUID;
    /**
     * @generated from protobuf field: bool is_active = 11
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal on_hand_v2 = 12
     */
    onHandV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal on_order_v2 = 13
     */
    onOrderV2?: Decimal;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_sale = 14
     */
    lastSale?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money retail_price = 15
     */
    retailPrice?: Money;
}
/**
 * LocationSettingsOption is a vendor-specific (code, label) option used for
 * per-location vendor settings such as warehouse ID and pricing tier.
 *
 * @generated from protobuf message rd.integrations.LocationSettingsOption
 */
export interface LocationSettingsOption {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string label = 2
     */
    label: string;
}
/**
 * @generated from protobuf enum rd.integrations.MessageStatus
 */
export enum MessageStatus {
    /**
     * @generated from protobuf enum value: MESSAGE_STATUS_PENDING = 0;
     */
    PENDING = 0,
    /**
     * Outgoing
     *
     * @generated from protobuf enum value: MESSAGE_STATUS_DELIVERED = 1;
     */
    DELIVERED = 1,
    /**
     * @generated from protobuf enum value: MESSAGE_STATUS_DELIVERY_FAILED = 2;
     */
    DELIVERY_FAILED = 2,
    /**
     * Incoming
     *
     * @generated from protobuf enum value: MESSAGE_STATUS_RECEIVED = 3;
     */
    RECEIVED = 3,
    /**
     * @generated from protobuf enum value: MESSAGE_STATUS_PROCESSING_FAILED = 4;
     */
    PROCESSING_FAILED = 4,
    /**
     * This is for the incoming message
     *
     * @generated from protobuf enum value: MESSAGE_STATUS_PROCESSED = 5;
     */
    PROCESSED = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class Message$Type extends MessageType<Message> {
    constructor() {
        super("rd.integrations.Message", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "sender_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "receiver_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "control_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "time", kind: "message", T: () => Timestamp },
            { no: 9, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "sftp_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "gcs_object_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "status", kind: "enum", T: () => ["rd.integrations.MessageStatus", MessageStatus, "MESSAGE_STATUS_"] },
            { no: 14, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "comments", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Message>): Message {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.senderId = "";
        message.receiverId = "";
        message.controlNumber = 0;
        message.address = "";
        message.username = "";
        message.sftpPath = "";
        message.gcsObjectName = "";
        message.status = 0;
        message.errorMessage = "";
        message.comments = "";
        if (value !== undefined)
            reflectionMergePartial<Message>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message): Message {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string sender_id */ 5:
                    message.senderId = reader.string();
                    break;
                case /* string receiver_id */ 6:
                    message.receiverId = reader.string();
                    break;
                case /* int32 control_number */ 7:
                    message.controlNumber = reader.int32();
                    break;
                case /* google.protobuf.Timestamp time */ 8:
                    message.time = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.time);
                    break;
                case /* string address */ 9:
                    message.address = reader.string();
                    break;
                case /* string username */ 10:
                    message.username = reader.string();
                    break;
                case /* string sftp_path */ 11:
                    message.sftpPath = reader.string();
                    break;
                case /* string gcs_object_name */ 12:
                    message.gcsObjectName = reader.string();
                    break;
                case /* rd.integrations.MessageStatus status */ 13:
                    message.status = reader.int32();
                    break;
                case /* string error_message */ 14:
                    message.errorMessage = reader.string();
                    break;
                case /* string comments */ 15:
                    message.comments = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string sender_id = 5; */
        if (message.senderId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.senderId);
        /* string receiver_id = 6; */
        if (message.receiverId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.receiverId);
        /* int32 control_number = 7; */
        if (message.controlNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.controlNumber);
        /* google.protobuf.Timestamp time = 8; */
        if (message.time)
            Timestamp.internalBinaryWrite(message.time, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string address = 9; */
        if (message.address !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.address);
        /* string username = 10; */
        if (message.username !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.username);
        /* string sftp_path = 11; */
        if (message.sftpPath !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.sftpPath);
        /* string gcs_object_name = 12; */
        if (message.gcsObjectName !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.gcsObjectName);
        /* rd.integrations.MessageStatus status = 13; */
        if (message.status !== 0)
            writer.tag(13, WireType.Varint).int32(message.status);
        /* string error_message = 14; */
        if (message.errorMessage !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.errorMessage);
        /* string comments = 15; */
        if (message.comments !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.comments);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.Message
 */
export const Message = new Message$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AckData$Type extends MessageType<AckData> {
    constructor() {
        super("rd.integrations.AckData", [
            { no: 1, name: "acknowledge_code", kind: "enum", T: () => ["rd.integrations.x12.AcknowledgeCode", AcknowledgeCode, "ACKNOWLEDGE_CODE_"] },
            { no: 2, name: "ack_group_id", kind: "message", T: () => UUID },
            { no: 3, name: "number_of_received_transaction_sets", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "number_of_accepted_transaction_sets", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "number_of_rejected_transaction_sets", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AckData>): AckData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.acknowledgeCode = 0;
        message.numberOfReceivedTransactionSets = 0;
        message.numberOfAcceptedTransactionSets = 0;
        message.numberOfRejectedTransactionSets = 0;
        if (value !== undefined)
            reflectionMergePartial<AckData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AckData): AckData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.integrations.x12.AcknowledgeCode acknowledge_code */ 1:
                    message.acknowledgeCode = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID ack_group_id */ 2:
                    message.ackGroupId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.ackGroupId);
                    break;
                case /* int32 number_of_received_transaction_sets */ 3:
                    message.numberOfReceivedTransactionSets = reader.int32();
                    break;
                case /* int32 number_of_accepted_transaction_sets */ 4:
                    message.numberOfAcceptedTransactionSets = reader.int32();
                    break;
                case /* int32 number_of_rejected_transaction_sets */ 5:
                    message.numberOfRejectedTransactionSets = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AckData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.integrations.x12.AcknowledgeCode acknowledge_code = 1; */
        if (message.acknowledgeCode !== 0)
            writer.tag(1, WireType.Varint).int32(message.acknowledgeCode);
        /* rd.proto.uuid.UUID ack_group_id = 2; */
        if (message.ackGroupId)
            UUID.internalBinaryWrite(message.ackGroupId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 number_of_received_transaction_sets = 3; */
        if (message.numberOfReceivedTransactionSets !== 0)
            writer.tag(3, WireType.Varint).int32(message.numberOfReceivedTransactionSets);
        /* int32 number_of_accepted_transaction_sets = 4; */
        if (message.numberOfAcceptedTransactionSets !== 0)
            writer.tag(4, WireType.Varint).int32(message.numberOfAcceptedTransactionSets);
        /* int32 number_of_rejected_transaction_sets = 5; */
        if (message.numberOfRejectedTransactionSets !== 0)
            writer.tag(5, WireType.Varint).int32(message.numberOfRejectedTransactionSets);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.AckData
 */
export const AckData = new AckData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShipmentData$Type extends MessageType<ShipmentData> {
    constructor() {
        super("rd.integrations.ShipmentData", [
            { no: 1, name: "shipment_message_log_id", kind: "message", T: () => UUID },
            { no: 2, name: "hierarchical_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "po_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ShipmentData>): ShipmentData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hierarchicalId = "";
        message.poIdentifier = "";
        message.date = "";
        if (value !== undefined)
            reflectionMergePartial<ShipmentData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ShipmentData): ShipmentData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID shipment_message_log_id */ 1:
                    message.shipmentMessageLogId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.shipmentMessageLogId);
                    break;
                case /* string hierarchical_id */ 2:
                    message.hierarchicalId = reader.string();
                    break;
                case /* string po_identifier */ 3:
                    message.poIdentifier = reader.string();
                    break;
                case /* string date */ 4:
                    message.date = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ShipmentData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID shipment_message_log_id = 1; */
        if (message.shipmentMessageLogId)
            UUID.internalBinaryWrite(message.shipmentMessageLogId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string hierarchical_id = 2; */
        if (message.hierarchicalId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.hierarchicalId);
        /* string po_identifier = 3; */
        if (message.poIdentifier !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.poIdentifier);
        /* string date = 4; */
        if (message.date !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.ShipmentData
 */
export const ShipmentData = new ShipmentData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Group$Type extends MessageType<Group> {
    constructor() {
        super("rd.integrations.Group", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "functional_identifier_code", kind: "enum", T: () => ["rd.integrations.x12.FunctionalIdentifierCode", FunctionalIdentifierCode] },
            { no: 6, name: "application_sender_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "application_receiver_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "control_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "message_id", kind: "message", T: () => UUID },
            { no: 10, name: "ack_data", kind: "message", T: () => AckData },
            { no: 13, name: "comments", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Group>): Group {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionalIdentifierCode = 0;
        message.applicationSenderCode = "";
        message.applicationReceiverCode = "";
        message.controlNumber = 0;
        message.comments = "";
        if (value !== undefined)
            reflectionMergePartial<Group>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Group): Group {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.integrations.x12.FunctionalIdentifierCode functional_identifier_code */ 5:
                    message.functionalIdentifierCode = reader.int32();
                    break;
                case /* string application_sender_code */ 6:
                    message.applicationSenderCode = reader.string();
                    break;
                case /* string application_receiver_code */ 7:
                    message.applicationReceiverCode = reader.string();
                    break;
                case /* int32 control_number */ 8:
                    message.controlNumber = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID message_id */ 9:
                    message.messageId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.messageId);
                    break;
                case /* rd.integrations.AckData ack_data */ 10:
                    message.ackData = AckData.internalBinaryRead(reader, reader.uint32(), options, message.ackData);
                    break;
                case /* string comments */ 13:
                    message.comments = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Group, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.integrations.x12.FunctionalIdentifierCode functional_identifier_code = 5; */
        if (message.functionalIdentifierCode !== 0)
            writer.tag(5, WireType.Varint).int32(message.functionalIdentifierCode);
        /* string application_sender_code = 6; */
        if (message.applicationSenderCode !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.applicationSenderCode);
        /* string application_receiver_code = 7; */
        if (message.applicationReceiverCode !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.applicationReceiverCode);
        /* int32 control_number = 8; */
        if (message.controlNumber !== 0)
            writer.tag(8, WireType.Varint).int32(message.controlNumber);
        /* rd.proto.uuid.UUID message_id = 9; */
        if (message.messageId)
            UUID.internalBinaryWrite(message.messageId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.integrations.AckData ack_data = 10; */
        if (message.ackData)
            AckData.internalBinaryWrite(message.ackData, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string comments = 13; */
        if (message.comments !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.comments);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.Group
 */
export const Group = new Group$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Order$Type extends MessageType<Order> {
    constructor() {
        super("rd.integrations.Order", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "control_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "group_id", kind: "message", T: () => UUID },
            { no: 7, name: "group_control_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "acknowledge_code", kind: "enum", T: () => ["rd.integrations.x12.AcknowledgeCode", AcknowledgeCode, "ACKNOWLEDGE_CODE_"] },
            { no: 10, name: "comments", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "txn_order_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Order>): Order {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.controlNumber = 0;
        message.groupControlNumber = 0;
        message.acknowledgeCode = 0;
        message.comments = "";
        if (value !== undefined)
            reflectionMergePartial<Order>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Order): Order {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string identifier */ 4:
                    message.identifier = reader.string();
                    break;
                case /* int32 control_number */ 5:
                    message.controlNumber = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID group_id */ 6:
                    message.groupId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.groupId);
                    break;
                case /* int32 group_control_number */ 7:
                    message.groupControlNumber = reader.int32();
                    break;
                case /* rd.integrations.x12.AcknowledgeCode acknowledge_code */ 8:
                    message.acknowledgeCode = reader.int32();
                    break;
                case /* string comments */ 10:
                    message.comments = reader.string();
                    break;
                case /* rd.proto.uuid.UUID txn_order_id */ 11:
                    message.txnOrderId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.txnOrderId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Order, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 4; */
        if (message.identifier !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.identifier);
        /* int32 control_number = 5; */
        if (message.controlNumber !== 0)
            writer.tag(5, WireType.Varint).int32(message.controlNumber);
        /* rd.proto.uuid.UUID group_id = 6; */
        if (message.groupId)
            UUID.internalBinaryWrite(message.groupId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* int32 group_control_number = 7; */
        if (message.groupControlNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.groupControlNumber);
        /* rd.integrations.x12.AcknowledgeCode acknowledge_code = 8; */
        if (message.acknowledgeCode !== 0)
            writer.tag(8, WireType.Varint).int32(message.acknowledgeCode);
        /* string comments = 10; */
        if (message.comments !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.comments);
        /* rd.proto.uuid.UUID txn_order_id = 11; */
        if (message.txnOrderId)
            UUID.internalBinaryWrite(message.txnOrderId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.Order
 */
export const Order = new Order$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MessageControlNumber$Type extends MessageType<MessageControlNumber> {
    constructor() {
        super("rd.integrations.MessageControlNumber", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "sender", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "receiver", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "control_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<MessageControlNumber>): MessageControlNumber {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sender = "";
        message.receiver = "";
        message.controlNumber = 0;
        if (value !== undefined)
            reflectionMergePartial<MessageControlNumber>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MessageControlNumber): MessageControlNumber {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string sender */ 4:
                    message.sender = reader.string();
                    break;
                case /* string receiver */ 5:
                    message.receiver = reader.string();
                    break;
                case /* int32 control_number */ 6:
                    message.controlNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MessageControlNumber, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string sender = 4; */
        if (message.sender !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.sender);
        /* string receiver = 5; */
        if (message.receiver !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.receiver);
        /* int32 control_number = 6; */
        if (message.controlNumber !== 0)
            writer.tag(6, WireType.Varint).int32(message.controlNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.MessageControlNumber
 */
export const MessageControlNumber = new MessageControlNumber$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GroupControlNumber$Type extends MessageType<GroupControlNumber> {
    constructor() {
        super("rd.integrations.GroupControlNumber", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "functional_identifier_code", kind: "enum", T: () => ["rd.integrations.x12.FunctionalIdentifierCode", FunctionalIdentifierCode] },
            { no: 5, name: "sender", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "receiver", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "control_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GroupControlNumber>): GroupControlNumber {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.functionalIdentifierCode = 0;
        message.sender = "";
        message.receiver = "";
        message.controlNumber = 0;
        if (value !== undefined)
            reflectionMergePartial<GroupControlNumber>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GroupControlNumber): GroupControlNumber {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.integrations.x12.FunctionalIdentifierCode functional_identifier_code */ 4:
                    message.functionalIdentifierCode = reader.int32();
                    break;
                case /* string sender */ 5:
                    message.sender = reader.string();
                    break;
                case /* string receiver */ 6:
                    message.receiver = reader.string();
                    break;
                case /* int32 control_number */ 7:
                    message.controlNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GroupControlNumber, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.integrations.x12.FunctionalIdentifierCode functional_identifier_code = 4; */
        if (message.functionalIdentifierCode !== 0)
            writer.tag(4, WireType.Varint).int32(message.functionalIdentifierCode);
        /* string sender = 5; */
        if (message.sender !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.sender);
        /* string receiver = 6; */
        if (message.receiver !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.receiver);
        /* int32 control_number = 7; */
        if (message.controlNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.controlNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.GroupControlNumber
 */
export const GroupControlNumber = new GroupControlNumber$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShipmentNotification$Type extends MessageType<ShipmentNotification> {
    constructor() {
        super("rd.integrations.ShipmentNotification", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "sender_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "company_id", kind: "message", T: () => UUID },
            { no: 6, name: "order_id", kind: "message", T: () => UUID },
            { no: 7, name: "total_shipped", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "shipped_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "location_id", kind: "message", T: () => UUID },
            { no: 11, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 13, name: "shipment_address", kind: "message", T: () => Address },
            { no: 14, name: "shipment_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "edi_message_id", kind: "message", T: () => UUID },
            { no: 16, name: "products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ShipmentNotification_Product },
            { no: 17, name: "status", kind: "enum", T: () => ["rd.integrations.ShipmentNotification.Status", ShipmentNotification_Status, "STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<ShipmentNotification>): ShipmentNotification {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.senderId = "";
        message.totalShipped = 0;
        message.notes = "";
        message.identifier = "";
        message.shipmentTo = "";
        message.products = [];
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<ShipmentNotification>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ShipmentNotification): ShipmentNotification {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string sender_id */ 4:
                    message.senderId = reader.string();
                    break;
                case /* rd.proto.uuid.UUID company_id */ 5:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID order_id */ 6:
                    message.orderId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderId);
                    break;
                case /* int32 total_shipped */ 7:
                    message.totalShipped = reader.int32();
                    break;
                case /* google.protobuf.Timestamp shipped_at */ 8:
                    message.shippedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.shippedAt);
                    break;
                case /* string notes */ 9:
                    message.notes = reader.string();
                    break;
                case /* rd.proto.uuid.UUID location_id */ 10:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string identifier */ 11:
                    message.identifier = reader.string();
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 12:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* rd.proto.address.Address shipment_address */ 13:
                    message.shipmentAddress = Address.internalBinaryRead(reader, reader.uint32(), options, message.shipmentAddress);
                    break;
                case /* string shipment_to */ 14:
                    message.shipmentTo = reader.string();
                    break;
                case /* rd.proto.uuid.UUID edi_message_id */ 15:
                    message.ediMessageId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.ediMessageId);
                    break;
                case /* repeated rd.integrations.ShipmentNotification.Product products */ 16:
                    message.products.push(ShipmentNotification_Product.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.integrations.ShipmentNotification.Status status */ 17:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ShipmentNotification, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string sender_id = 4; */
        if (message.senderId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.senderId);
        /* rd.proto.uuid.UUID company_id = 5; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_id = 6; */
        if (message.orderId)
            UUID.internalBinaryWrite(message.orderId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_shipped = 7; */
        if (message.totalShipped !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalShipped);
        /* google.protobuf.Timestamp shipped_at = 8; */
        if (message.shippedAt)
            Timestamp.internalBinaryWrite(message.shippedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 9; */
        if (message.notes !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.notes);
        /* rd.proto.uuid.UUID location_id = 10; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 11; */
        if (message.identifier !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.identifier);
        /* rd.proto.uuid.UUID vendor_id = 12; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.address.Address shipment_address = 13; */
        if (message.shipmentAddress)
            Address.internalBinaryWrite(message.shipmentAddress, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* string shipment_to = 14; */
        if (message.shipmentTo !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.shipmentTo);
        /* rd.proto.uuid.UUID edi_message_id = 15; */
        if (message.ediMessageId)
            UUID.internalBinaryWrite(message.ediMessageId, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.integrations.ShipmentNotification.Product products = 16; */
        for (let i = 0; i < message.products.length; i++)
            ShipmentNotification_Product.internalBinaryWrite(message.products[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.integrations.ShipmentNotification.Status status = 17; */
        if (message.status !== 0)
            writer.tag(17, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.ShipmentNotification
 */
export const ShipmentNotification = new ShipmentNotification$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShipmentNotification_Product$Type extends MessageType<ShipmentNotification_Product> {
    constructor() {
        super("rd.integrations.ShipmentNotification.Product", [
            { no: 1, name: "product_id", kind: "message", T: () => UUID },
            { no: 2, name: "quantity_shipped", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "cost", kind: "message", T: () => Decimal },
            { no: 4, name: "unit_of_measurement", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "quantity_ordered", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "retail_price", kind: "message", T: () => Decimal },
            { no: 7, name: "sku", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "quantity_shipped_v2", kind: "message", T: () => Decimal },
            { no: 9, name: "quantity_ordered_v2", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<ShipmentNotification_Product>): ShipmentNotification_Product {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.quantityShipped = 0;
        message.unitOfMeasurement = "";
        message.quantityOrdered = 0;
        message.sku = "";
        if (value !== undefined)
            reflectionMergePartial<ShipmentNotification_Product>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ShipmentNotification_Product): ShipmentNotification_Product {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID product_id */ 1:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* int32 quantity_shipped */ 2:
                    message.quantityShipped = reader.int32();
                    break;
                case /* rd.proto.decimal.Decimal cost */ 3:
                    message.cost = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* string unit_of_measurement */ 4:
                    message.unitOfMeasurement = reader.string();
                    break;
                case /* int32 quantity_ordered */ 5:
                    message.quantityOrdered = reader.int32();
                    break;
                case /* rd.proto.decimal.Decimal retail_price */ 6:
                    message.retailPrice = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.retailPrice);
                    break;
                case /* string sku */ 7:
                    message.sku = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal quantity_shipped_v2 */ 8:
                    message.quantityShippedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityShippedV2);
                    break;
                case /* rd.proto.decimal.Decimal quantity_ordered_v2 */ 9:
                    message.quantityOrderedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityOrderedV2);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ShipmentNotification_Product, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID product_id = 1; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 quantity_shipped = 2; */
        if (message.quantityShipped !== 0)
            writer.tag(2, WireType.Varint).int32(message.quantityShipped);
        /* rd.proto.decimal.Decimal cost = 3; */
        if (message.cost)
            Decimal.internalBinaryWrite(message.cost, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string unit_of_measurement = 4; */
        if (message.unitOfMeasurement !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.unitOfMeasurement);
        /* int32 quantity_ordered = 5; */
        if (message.quantityOrdered !== 0)
            writer.tag(5, WireType.Varint).int32(message.quantityOrdered);
        /* rd.proto.decimal.Decimal retail_price = 6; */
        if (message.retailPrice)
            Decimal.internalBinaryWrite(message.retailPrice, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string sku = 7; */
        if (message.sku !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.sku);
        /* rd.proto.decimal.Decimal quantity_shipped_v2 = 8; */
        if (message.quantityShippedV2)
            Decimal.internalBinaryWrite(message.quantityShippedV2, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_ordered_v2 = 9; */
        if (message.quantityOrderedV2)
            Decimal.internalBinaryWrite(message.quantityOrderedV2, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.ShipmentNotification.Product
 */
export const ShipmentNotification_Product = new ShipmentNotification_Product$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PriceChange$Type extends MessageType<PriceChange> {
    constructor() {
        super("rd.integrations.PriceChange", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "sender_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 6, name: "gcs_object_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "customer_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "sku", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "effective_date", kind: "message", T: () => Timestamp },
            { no: 11, name: "vendor_retail", kind: "message", T: () => Money },
            { no: 12, name: "unit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "upc", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "retail_class", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "promotional", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "vendor_cost_v2", kind: "message", T: () => FractionalMoney },
            { no: 17, name: "company_id", kind: "message", T: () => UUID },
            { no: 18, name: "product_id", kind: "message", T: () => UUID },
            { no: 19, name: "status", kind: "enum", T: () => ["rd.integrations.PriceChange.Status", PriceChange_Status, "STATUS_"] },
            { no: 20, name: "integration_vendor", kind: "enum", T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] },
            { no: 21, name: "do_it_best_price_change", kind: "message", T: () => PriceChange_DoItBestPriceChange },
            { no: 22, name: "sale_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "sale_starts_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "sale_ends_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<PriceChange>): PriceChange {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.senderId = "";
        message.gcsObjectName = "";
        message.customerNumber = "";
        message.sku = "";
        message.unit = "";
        message.upc = "";
        message.retailClass = "";
        message.promotional = false;
        message.status = 0;
        message.integrationVendor = 0;
        message.saleCode = "";
        if (value !== undefined)
            reflectionMergePartial<PriceChange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PriceChange): PriceChange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string sender_id */ 4:
                    message.senderId = reader.string();
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 5:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* string gcs_object_name */ 6:
                    message.gcsObjectName = reader.string();
                    break;
                case /* string customer_number */ 7:
                    message.customerNumber = reader.string();
                    break;
                case /* string sku */ 8:
                    message.sku = reader.string();
                    break;
                case /* google.protobuf.Timestamp effective_date */ 9:
                    message.effectiveDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.effectiveDate);
                    break;
                case /* rd.proto.money.Money vendor_retail */ 11:
                    message.vendorRetail = Money.internalBinaryRead(reader, reader.uint32(), options, message.vendorRetail);
                    break;
                case /* string unit */ 12:
                    message.unit = reader.string();
                    break;
                case /* string upc */ 13:
                    message.upc = reader.string();
                    break;
                case /* string retail_class */ 14:
                    message.retailClass = reader.string();
                    break;
                case /* bool promotional */ 15:
                    message.promotional = reader.bool();
                    break;
                case /* rd.proto.money.FractionalMoney vendor_cost_v2 */ 16:
                    message.vendorCostV2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.vendorCostV2);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 17:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 18:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.integrations.PriceChange.Status status */ 19:
                    message.status = reader.int32();
                    break;
                case /* rd.proto.integration_vendor.IntegrationVendor integration_vendor */ 20:
                    message.integrationVendor = reader.int32();
                    break;
                case /* rd.integrations.PriceChange.DoItBestPriceChange do_it_best_price_change */ 21:
                    message.doItBestPriceChange = PriceChange_DoItBestPriceChange.internalBinaryRead(reader, reader.uint32(), options, message.doItBestPriceChange);
                    break;
                case /* string sale_code */ 22:
                    message.saleCode = reader.string();
                    break;
                case /* google.protobuf.Timestamp sale_starts_at */ 23:
                    message.saleStartsAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.saleStartsAt);
                    break;
                case /* google.protobuf.Timestamp sale_ends_at */ 24:
                    message.saleEndsAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.saleEndsAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PriceChange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string sender_id = 4; */
        if (message.senderId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.senderId);
        /* rd.proto.uuid.UUID vendor_id = 5; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string gcs_object_name = 6; */
        if (message.gcsObjectName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.gcsObjectName);
        /* string customer_number = 7; */
        if (message.customerNumber !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.customerNumber);
        /* string sku = 8; */
        if (message.sku !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.sku);
        /* google.protobuf.Timestamp effective_date = 9; */
        if (message.effectiveDate)
            Timestamp.internalBinaryWrite(message.effectiveDate, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money vendor_retail = 11; */
        if (message.vendorRetail)
            Money.internalBinaryWrite(message.vendorRetail, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string unit = 12; */
        if (message.unit !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.unit);
        /* string upc = 13; */
        if (message.upc !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.upc);
        /* string retail_class = 14; */
        if (message.retailClass !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.retailClass);
        /* bool promotional = 15; */
        if (message.promotional !== false)
            writer.tag(15, WireType.Varint).bool(message.promotional);
        /* rd.proto.money.FractionalMoney vendor_cost_v2 = 16; */
        if (message.vendorCostV2)
            FractionalMoney.internalBinaryWrite(message.vendorCostV2, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 17; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 18; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.integrations.PriceChange.Status status = 19; */
        if (message.status !== 0)
            writer.tag(19, WireType.Varint).int32(message.status);
        /* rd.proto.integration_vendor.IntegrationVendor integration_vendor = 20; */
        if (message.integrationVendor !== 0)
            writer.tag(20, WireType.Varint).int32(message.integrationVendor);
        /* rd.integrations.PriceChange.DoItBestPriceChange do_it_best_price_change = 21; */
        if (message.doItBestPriceChange)
            PriceChange_DoItBestPriceChange.internalBinaryWrite(message.doItBestPriceChange, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* string sale_code = 22; */
        if (message.saleCode !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.saleCode);
        /* google.protobuf.Timestamp sale_starts_at = 23; */
        if (message.saleStartsAt)
            Timestamp.internalBinaryWrite(message.saleStartsAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sale_ends_at = 24; */
        if (message.saleEndsAt)
            Timestamp.internalBinaryWrite(message.saleEndsAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.PriceChange
 */
export const PriceChange = new PriceChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PriceChange_DoItBestPriceChange$Type extends MessageType<PriceChange_DoItBestPriceChange> {
    constructor() {
        super("rd.integrations.PriceChange.DoItBestPriceChange", [
            { no: 1, name: "record_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "member_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sku", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "product_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "item_price_change", kind: "message", T: () => FractionalMoney },
            { no: 6, name: "unit_of_measure", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "item_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "price_status_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "effective_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "promo_status_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "reorder_start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "reorder_end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "sale_start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "sale_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "sale_end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "member_cost_option", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "mult_3", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "cost_3", kind: "message", T: () => FractionalMoney },
            { no: 19, name: "mult_2", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "cost_2", kind: "message", T: () => FractionalMoney },
            { no: 21, name: "mult_1", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 22, name: "cost_1", kind: "message", T: () => FractionalMoney },
            { no: 23, name: "member_retail", kind: "message", T: () => Money },
            { no: 24, name: "gross_margin", kind: "message", T: () => Decimal },
            { no: 25, name: "suggested_retail", kind: "message", T: () => Money },
            { no: 26, name: "suggested_aux_retail", kind: "message", T: () => Money },
            { no: 27, name: "suggested_margin", kind: "message", T: () => Decimal },
            { no: 28, name: "do_it_best_corp_use", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 29, name: "mbr_aux_retail_switch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "aux_unit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "aux_qty", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 32, name: "status_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "personal_sku", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PriceChange_DoItBestPriceChange>): PriceChange_DoItBestPriceChange {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.recordCode = "";
        message.memberNumber = "";
        message.sku = "";
        message.productCode = "";
        message.unitOfMeasure = "";
        message.itemType = "";
        message.priceStatusCode = "";
        message.effectiveDate = "";
        message.promoStatusCode = "";
        message.reorderStartDate = "";
        message.reorderEndDate = "";
        message.saleStartDate = "";
        message.saleCode = "";
        message.saleEndDate = "";
        message.memberCostOption = "";
        message.mult3 = 0;
        message.mult2 = 0;
        message.mult1 = 0;
        message.doItBestCorpUse = 0;
        message.mbrAuxRetailSwitch = "";
        message.auxUnit = "";
        message.auxQty = 0;
        message.statusCode = "";
        message.personalSku = "";
        if (value !== undefined)
            reflectionMergePartial<PriceChange_DoItBestPriceChange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PriceChange_DoItBestPriceChange): PriceChange_DoItBestPriceChange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string record_code */ 1:
                    message.recordCode = reader.string();
                    break;
                case /* string member_number */ 2:
                    message.memberNumber = reader.string();
                    break;
                case /* string sku */ 3:
                    message.sku = reader.string();
                    break;
                case /* string product_code */ 4:
                    message.productCode = reader.string();
                    break;
                case /* rd.proto.money.FractionalMoney item_price_change */ 5:
                    message.itemPriceChange = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.itemPriceChange);
                    break;
                case /* string unit_of_measure */ 6:
                    message.unitOfMeasure = reader.string();
                    break;
                case /* string item_type */ 7:
                    message.itemType = reader.string();
                    break;
                case /* string price_status_code */ 8:
                    message.priceStatusCode = reader.string();
                    break;
                case /* string effective_date */ 9:
                    message.effectiveDate = reader.string();
                    break;
                case /* string promo_status_code */ 10:
                    message.promoStatusCode = reader.string();
                    break;
                case /* string reorder_start_date */ 11:
                    message.reorderStartDate = reader.string();
                    break;
                case /* string reorder_end_date */ 12:
                    message.reorderEndDate = reader.string();
                    break;
                case /* string sale_start_date */ 13:
                    message.saleStartDate = reader.string();
                    break;
                case /* string sale_code */ 14:
                    message.saleCode = reader.string();
                    break;
                case /* string sale_end_date */ 15:
                    message.saleEndDate = reader.string();
                    break;
                case /* string member_cost_option */ 16:
                    message.memberCostOption = reader.string();
                    break;
                case /* int32 mult_3 */ 17:
                    message.mult3 = reader.int32();
                    break;
                case /* rd.proto.money.FractionalMoney cost_3 */ 18:
                    message.cost3 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost3);
                    break;
                case /* int32 mult_2 */ 19:
                    message.mult2 = reader.int32();
                    break;
                case /* rd.proto.money.FractionalMoney cost_2 */ 20:
                    message.cost2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost2);
                    break;
                case /* int32 mult_1 */ 21:
                    message.mult1 = reader.int32();
                    break;
                case /* rd.proto.money.FractionalMoney cost_1 */ 22:
                    message.cost1 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost1);
                    break;
                case /* rd.proto.money.Money member_retail */ 23:
                    message.memberRetail = Money.internalBinaryRead(reader, reader.uint32(), options, message.memberRetail);
                    break;
                case /* rd.proto.decimal.Decimal gross_margin */ 24:
                    message.grossMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.grossMargin);
                    break;
                case /* rd.proto.money.Money suggested_retail */ 25:
                    message.suggestedRetail = Money.internalBinaryRead(reader, reader.uint32(), options, message.suggestedRetail);
                    break;
                case /* rd.proto.money.Money suggested_aux_retail */ 26:
                    message.suggestedAuxRetail = Money.internalBinaryRead(reader, reader.uint32(), options, message.suggestedAuxRetail);
                    break;
                case /* rd.proto.decimal.Decimal suggested_margin */ 27:
                    message.suggestedMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.suggestedMargin);
                    break;
                case /* int32 do_it_best_corp_use */ 28:
                    message.doItBestCorpUse = reader.int32();
                    break;
                case /* string mbr_aux_retail_switch */ 29:
                    message.mbrAuxRetailSwitch = reader.string();
                    break;
                case /* string aux_unit */ 30:
                    message.auxUnit = reader.string();
                    break;
                case /* int32 aux_qty */ 31:
                    message.auxQty = reader.int32();
                    break;
                case /* string status_code */ 32:
                    message.statusCode = reader.string();
                    break;
                case /* string personal_sku */ 33:
                    message.personalSku = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PriceChange_DoItBestPriceChange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string record_code = 1; */
        if (message.recordCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.recordCode);
        /* string member_number = 2; */
        if (message.memberNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.memberNumber);
        /* string sku = 3; */
        if (message.sku !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sku);
        /* string product_code = 4; */
        if (message.productCode !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.productCode);
        /* rd.proto.money.FractionalMoney item_price_change = 5; */
        if (message.itemPriceChange)
            FractionalMoney.internalBinaryWrite(message.itemPriceChange, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string unit_of_measure = 6; */
        if (message.unitOfMeasure !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.unitOfMeasure);
        /* string item_type = 7; */
        if (message.itemType !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.itemType);
        /* string price_status_code = 8; */
        if (message.priceStatusCode !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.priceStatusCode);
        /* string effective_date = 9; */
        if (message.effectiveDate !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.effectiveDate);
        /* string promo_status_code = 10; */
        if (message.promoStatusCode !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.promoStatusCode);
        /* string reorder_start_date = 11; */
        if (message.reorderStartDate !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.reorderStartDate);
        /* string reorder_end_date = 12; */
        if (message.reorderEndDate !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.reorderEndDate);
        /* string sale_start_date = 13; */
        if (message.saleStartDate !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.saleStartDate);
        /* string sale_code = 14; */
        if (message.saleCode !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.saleCode);
        /* string sale_end_date = 15; */
        if (message.saleEndDate !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.saleEndDate);
        /* string member_cost_option = 16; */
        if (message.memberCostOption !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.memberCostOption);
        /* int32 mult_3 = 17; */
        if (message.mult3 !== 0)
            writer.tag(17, WireType.Varint).int32(message.mult3);
        /* rd.proto.money.FractionalMoney cost_3 = 18; */
        if (message.cost3)
            FractionalMoney.internalBinaryWrite(message.cost3, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* int32 mult_2 = 19; */
        if (message.mult2 !== 0)
            writer.tag(19, WireType.Varint).int32(message.mult2);
        /* rd.proto.money.FractionalMoney cost_2 = 20; */
        if (message.cost2)
            FractionalMoney.internalBinaryWrite(message.cost2, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* int32 mult_1 = 21; */
        if (message.mult1 !== 0)
            writer.tag(21, WireType.Varint).int32(message.mult1);
        /* rd.proto.money.FractionalMoney cost_1 = 22; */
        if (message.cost1)
            FractionalMoney.internalBinaryWrite(message.cost1, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money member_retail = 23; */
        if (message.memberRetail)
            Money.internalBinaryWrite(message.memberRetail, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal gross_margin = 24; */
        if (message.grossMargin)
            Decimal.internalBinaryWrite(message.grossMargin, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money suggested_retail = 25; */
        if (message.suggestedRetail)
            Money.internalBinaryWrite(message.suggestedRetail, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money suggested_aux_retail = 26; */
        if (message.suggestedAuxRetail)
            Money.internalBinaryWrite(message.suggestedAuxRetail, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal suggested_margin = 27; */
        if (message.suggestedMargin)
            Decimal.internalBinaryWrite(message.suggestedMargin, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* int32 do_it_best_corp_use = 28; */
        if (message.doItBestCorpUse !== 0)
            writer.tag(28, WireType.Varint).int32(message.doItBestCorpUse);
        /* string mbr_aux_retail_switch = 29; */
        if (message.mbrAuxRetailSwitch !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.mbrAuxRetailSwitch);
        /* string aux_unit = 30; */
        if (message.auxUnit !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.auxUnit);
        /* int32 aux_qty = 31; */
        if (message.auxQty !== 0)
            writer.tag(31, WireType.Varint).int32(message.auxQty);
        /* string status_code = 32; */
        if (message.statusCode !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.statusCode);
        /* string personal_sku = 33; */
        if (message.personalSku !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.personalSku);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.PriceChange.DoItBestPriceChange
 */
export const PriceChange_DoItBestPriceChange = new PriceChange_DoItBestPriceChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProcessedFile$Type extends MessageType<ProcessedFile> {
    constructor() {
        super("rd.integrations.ProcessedFile", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "sender_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "processed_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "content_hash", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ProcessedFile>): ProcessedFile {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.senderId = "";
        message.fileName = "";
        message.contentHash = "";
        if (value !== undefined)
            reflectionMergePartial<ProcessedFile>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProcessedFile): ProcessedFile {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string sender_id */ 2:
                    message.senderId = reader.string();
                    break;
                case /* string file_name */ 3:
                    message.fileName = reader.string();
                    break;
                case /* google.protobuf.Timestamp processed_at */ 4:
                    message.processedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.processedAt);
                    break;
                case /* string content_hash */ 5:
                    message.contentHash = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProcessedFile, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string sender_id = 2; */
        if (message.senderId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.senderId);
        /* string file_name = 3; */
        if (message.fileName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.fileName);
        /* google.protobuf.Timestamp processed_at = 4; */
        if (message.processedAt)
            Timestamp.internalBinaryWrite(message.processedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string content_hash = 5; */
        if (message.contentHash !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.contentHash);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.ProcessedFile
 */
export const ProcessedFile = new ProcessedFile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceItemData$Type extends MessageType<InvoiceItemData> {
    constructor() {
        super("rd.integrations.InvoiceItemData", [
            { no: 1, name: "assigned_identification", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "quantity_invoiced", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "unit_of_measurement", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "unit_price", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "product_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "product_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<InvoiceItemData>): InvoiceItemData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assignedIdentification = "";
        message.quantityInvoiced = "";
        message.unitOfMeasurement = "";
        message.unitPrice = "";
        message.productName = "";
        message.productId = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<InvoiceItemData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InvoiceItemData): InvoiceItemData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string assigned_identification */ 1:
                    message.assignedIdentification = reader.string();
                    break;
                case /* string quantity_invoiced */ 2:
                    message.quantityInvoiced = reader.string();
                    break;
                case /* string unit_of_measurement */ 3:
                    message.unitOfMeasurement = reader.string();
                    break;
                case /* string unit_price */ 4:
                    message.unitPrice = reader.string();
                    break;
                case /* string product_name */ 5:
                    message.productName = reader.string();
                    break;
                case /* string product_id */ 6:
                    message.productId = reader.string();
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InvoiceItemData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string assigned_identification = 1; */
        if (message.assignedIdentification !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.assignedIdentification);
        /* string quantity_invoiced = 2; */
        if (message.quantityInvoiced !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.quantityInvoiced);
        /* string unit_of_measurement = 3; */
        if (message.unitOfMeasurement !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.unitOfMeasurement);
        /* string unit_price = 4; */
        if (message.unitPrice !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.unitPrice);
        /* string product_name = 5; */
        if (message.productName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.productName);
        /* string product_id = 6; */
        if (message.productId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.productId);
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.InvoiceItemData
 */
export const InvoiceItemData = new InvoiceItemData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Invoice$Type extends MessageType<Invoice> {
    constructor() {
        super("rd.integrations.Invoice", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "sender_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "company_id", kind: "message", T: () => UUID },
            { no: 6, name: "order_id", kind: "message", T: () => UUID },
            { no: 7, name: "invoice_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "invoice_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "po_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "po_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "debit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "charge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "total_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "charge_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "misc_charge_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "number_of_units_shipped", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "unit_of_measurement", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "identification_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "order_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "terms_discount_percent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "terms_discount_due_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "terms_net_due_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "terms_discount_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 25, name: "terms_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InvoiceItemData }
        ]);
    }
    create(value?: PartialMessage<Invoice>): Invoice {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.senderId = "";
        message.invoiceDate = "";
        message.invoiceNumber = "";
        message.poDate = "";
        message.poNumber = "";
        message.debit = false;
        message.charge = false;
        message.totalAmount = 0;
        message.chargeAmount = 0;
        message.miscChargeDescription = "";
        message.numberOfUnitsShipped = "";
        message.unitOfMeasurement = "";
        message.name = "";
        message.identificationCode = "";
        message.orderNumber = "";
        message.termsDiscountPercent = "";
        message.termsDiscountDueDate = "";
        message.termsNetDueDate = "";
        message.termsDiscountAmount = 0;
        message.termsDescription = "";
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Invoice>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Invoice): Invoice {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string sender_id */ 4:
                    message.senderId = reader.string();
                    break;
                case /* rd.proto.uuid.UUID company_id */ 5:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID order_id */ 6:
                    message.orderId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderId);
                    break;
                case /* string invoice_date */ 7:
                    message.invoiceDate = reader.string();
                    break;
                case /* string invoice_number */ 8:
                    message.invoiceNumber = reader.string();
                    break;
                case /* string po_date */ 9:
                    message.poDate = reader.string();
                    break;
                case /* string po_number */ 10:
                    message.poNumber = reader.string();
                    break;
                case /* bool debit */ 11:
                    message.debit = reader.bool();
                    break;
                case /* bool charge */ 12:
                    message.charge = reader.bool();
                    break;
                case /* double total_amount */ 13:
                    message.totalAmount = reader.double();
                    break;
                case /* double charge_amount */ 14:
                    message.chargeAmount = reader.double();
                    break;
                case /* string misc_charge_description */ 15:
                    message.miscChargeDescription = reader.string();
                    break;
                case /* string number_of_units_shipped */ 16:
                    message.numberOfUnitsShipped = reader.string();
                    break;
                case /* string unit_of_measurement */ 17:
                    message.unitOfMeasurement = reader.string();
                    break;
                case /* string name */ 18:
                    message.name = reader.string();
                    break;
                case /* string identification_code */ 19:
                    message.identificationCode = reader.string();
                    break;
                case /* string order_number */ 20:
                    message.orderNumber = reader.string();
                    break;
                case /* string terms_discount_percent */ 21:
                    message.termsDiscountPercent = reader.string();
                    break;
                case /* string terms_discount_due_date */ 22:
                    message.termsDiscountDueDate = reader.string();
                    break;
                case /* string terms_net_due_date */ 23:
                    message.termsNetDueDate = reader.string();
                    break;
                case /* double terms_discount_amount */ 24:
                    message.termsDiscountAmount = reader.double();
                    break;
                case /* string terms_description */ 25:
                    message.termsDescription = reader.string();
                    break;
                case /* repeated rd.integrations.InvoiceItemData items */ 26:
                    message.items.push(InvoiceItemData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Invoice, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string sender_id = 4; */
        if (message.senderId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.senderId);
        /* rd.proto.uuid.UUID company_id = 5; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_id = 6; */
        if (message.orderId)
            UUID.internalBinaryWrite(message.orderId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string invoice_date = 7; */
        if (message.invoiceDate !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.invoiceDate);
        /* string invoice_number = 8; */
        if (message.invoiceNumber !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.invoiceNumber);
        /* string po_date = 9; */
        if (message.poDate !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.poDate);
        /* string po_number = 10; */
        if (message.poNumber !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.poNumber);
        /* bool debit = 11; */
        if (message.debit !== false)
            writer.tag(11, WireType.Varint).bool(message.debit);
        /* bool charge = 12; */
        if (message.charge !== false)
            writer.tag(12, WireType.Varint).bool(message.charge);
        /* double total_amount = 13; */
        if (message.totalAmount !== 0)
            writer.tag(13, WireType.Bit64).double(message.totalAmount);
        /* double charge_amount = 14; */
        if (message.chargeAmount !== 0)
            writer.tag(14, WireType.Bit64).double(message.chargeAmount);
        /* string misc_charge_description = 15; */
        if (message.miscChargeDescription !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.miscChargeDescription);
        /* string number_of_units_shipped = 16; */
        if (message.numberOfUnitsShipped !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.numberOfUnitsShipped);
        /* string unit_of_measurement = 17; */
        if (message.unitOfMeasurement !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.unitOfMeasurement);
        /* string name = 18; */
        if (message.name !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.name);
        /* string identification_code = 19; */
        if (message.identificationCode !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.identificationCode);
        /* string order_number = 20; */
        if (message.orderNumber !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.orderNumber);
        /* string terms_discount_percent = 21; */
        if (message.termsDiscountPercent !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.termsDiscountPercent);
        /* string terms_discount_due_date = 22; */
        if (message.termsDiscountDueDate !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.termsDiscountDueDate);
        /* string terms_net_due_date = 23; */
        if (message.termsNetDueDate !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.termsNetDueDate);
        /* double terms_discount_amount = 24; */
        if (message.termsDiscountAmount !== 0)
            writer.tag(24, WireType.Bit64).double(message.termsDiscountAmount);
        /* string terms_description = 25; */
        if (message.termsDescription !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.termsDescription);
        /* repeated rd.integrations.InvoiceItemData items = 26; */
        for (let i = 0; i < message.items.length; i++)
            InvoiceItemData.internalBinaryWrite(message.items[i], writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.Invoice
 */
export const Invoice = new Invoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FanBuilderCustomer$Type extends MessageType<FanBuilderCustomer> {
    constructor() {
        super("rd.integrations.FanBuilderCustomer", [
            { no: 1, name: "system_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "employee_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "contact_via", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "middle_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "full_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "company_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "address1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "address2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "zip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "country", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "birth_month", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "mobile_phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FanBuilderCustomer>): FanBuilderCustomer {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.systemCustomerId = "";
        message.customerType = "";
        message.firstName = "";
        message.lastName = "";
        message.employeeId = "";
        message.contactVia = "";
        message.middleName = "";
        message.fullName = "";
        message.companyName = "";
        message.address1 = "";
        message.address2 = "";
        message.city = "";
        message.state = "";
        message.zip = "";
        message.country = "";
        message.email = "";
        message.birthMonth = 0;
        message.mobilePhone = "";
        if (value !== undefined)
            reflectionMergePartial<FanBuilderCustomer>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FanBuilderCustomer): FanBuilderCustomer {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string system_customer_id */ 1:
                    message.systemCustomerId = reader.string();
                    break;
                case /* string customer_type */ 2:
                    message.customerType = reader.string();
                    break;
                case /* string first_name */ 3:
                    message.firstName = reader.string();
                    break;
                case /* string last_name */ 4:
                    message.lastName = reader.string();
                    break;
                case /* string employee_id */ 5:
                    message.employeeId = reader.string();
                    break;
                case /* string contact_via */ 6:
                    message.contactVia = reader.string();
                    break;
                case /* string middle_name */ 7:
                    message.middleName = reader.string();
                    break;
                case /* string full_name */ 8:
                    message.fullName = reader.string();
                    break;
                case /* string company_name */ 9:
                    message.companyName = reader.string();
                    break;
                case /* string address1 */ 10:
                    message.address1 = reader.string();
                    break;
                case /* string address2 */ 11:
                    message.address2 = reader.string();
                    break;
                case /* string city */ 12:
                    message.city = reader.string();
                    break;
                case /* string state */ 13:
                    message.state = reader.string();
                    break;
                case /* string zip */ 14:
                    message.zip = reader.string();
                    break;
                case /* string country */ 15:
                    message.country = reader.string();
                    break;
                case /* string email */ 16:
                    message.email = reader.string();
                    break;
                case /* int32 birth_month */ 17:
                    message.birthMonth = reader.int32();
                    break;
                case /* string mobile_phone */ 18:
                    message.mobilePhone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FanBuilderCustomer, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string system_customer_id = 1; */
        if (message.systemCustomerId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.systemCustomerId);
        /* string customer_type = 2; */
        if (message.customerType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerType);
        /* string first_name = 3; */
        if (message.firstName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.firstName);
        /* string last_name = 4; */
        if (message.lastName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.lastName);
        /* string employee_id = 5; */
        if (message.employeeId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.employeeId);
        /* string contact_via = 6; */
        if (message.contactVia !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.contactVia);
        /* string middle_name = 7; */
        if (message.middleName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.middleName);
        /* string full_name = 8; */
        if (message.fullName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.fullName);
        /* string company_name = 9; */
        if (message.companyName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.companyName);
        /* string address1 = 10; */
        if (message.address1 !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.address1);
        /* string address2 = 11; */
        if (message.address2 !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.address2);
        /* string city = 12; */
        if (message.city !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.city);
        /* string state = 13; */
        if (message.state !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.state);
        /* string zip = 14; */
        if (message.zip !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.zip);
        /* string country = 15; */
        if (message.country !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.country);
        /* string email = 16; */
        if (message.email !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.email);
        /* int32 birth_month = 17; */
        if (message.birthMonth !== 0)
            writer.tag(17, WireType.Varint).int32(message.birthMonth);
        /* string mobile_phone = 18; */
        if (message.mobilePhone !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.mobilePhone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.FanBuilderCustomer
 */
export const FanBuilderCustomer = new FanBuilderCustomer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FanBuilderUseCouponRequest$Type extends MessageType<FanBuilderUseCouponRequest> {
    constructor() {
        super("rd.integrations.FanBuilderUseCouponRequest", [
            { no: 1, name: "customer", kind: "message", T: () => FanBuilderCustomer },
            { no: 2, name: "subtotal", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "coupon_details", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FanBuilderUseCouponRequest_CouponDetail }
        ]);
    }
    create(value?: PartialMessage<FanBuilderUseCouponRequest>): FanBuilderUseCouponRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subtotal = 0;
        message.couponDetails = [];
        if (value !== undefined)
            reflectionMergePartial<FanBuilderUseCouponRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FanBuilderUseCouponRequest): FanBuilderUseCouponRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.integrations.FanBuilderCustomer customer */ 1:
                    message.customer = FanBuilderCustomer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* double subtotal */ 2:
                    message.subtotal = reader.double();
                    break;
                case /* repeated rd.integrations.FanBuilderUseCouponRequest.CouponDetail coupon_details */ 3:
                    message.couponDetails.push(FanBuilderUseCouponRequest_CouponDetail.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FanBuilderUseCouponRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.integrations.FanBuilderCustomer customer = 1; */
        if (message.customer)
            FanBuilderCustomer.internalBinaryWrite(message.customer, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* double subtotal = 2; */
        if (message.subtotal !== 0)
            writer.tag(2, WireType.Bit64).double(message.subtotal);
        /* repeated rd.integrations.FanBuilderUseCouponRequest.CouponDetail coupon_details = 3; */
        for (let i = 0; i < message.couponDetails.length; i++)
            FanBuilderUseCouponRequest_CouponDetail.internalBinaryWrite(message.couponDetails[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.FanBuilderUseCouponRequest
 */
export const FanBuilderUseCouponRequest = new FanBuilderUseCouponRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FanBuilderUseCouponRequest_CouponDetail$Type extends MessageType<FanBuilderUseCouponRequest_CouponDetail> {
    constructor() {
        super("rd.integrations.FanBuilderUseCouponRequest.CouponDetail", [
            { no: 1, name: "coupon_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "taxable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "discount_type", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<FanBuilderUseCouponRequest_CouponDetail>): FanBuilderUseCouponRequest_CouponDetail {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.couponCode = "";
        message.amount = 0;
        message.taxable = false;
        message.discountType = 0;
        message.rate = 0;
        if (value !== undefined)
            reflectionMergePartial<FanBuilderUseCouponRequest_CouponDetail>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FanBuilderUseCouponRequest_CouponDetail): FanBuilderUseCouponRequest_CouponDetail {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string coupon_code */ 1:
                    message.couponCode = reader.string();
                    break;
                case /* double amount */ 2:
                    message.amount = reader.double();
                    break;
                case /* bool taxable */ 3:
                    message.taxable = reader.bool();
                    break;
                case /* int32 discount_type */ 4:
                    message.discountType = reader.int32();
                    break;
                case /* double rate */ 5:
                    message.rate = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FanBuilderUseCouponRequest_CouponDetail, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string coupon_code = 1; */
        if (message.couponCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.couponCode);
        /* double amount = 2; */
        if (message.amount !== 0)
            writer.tag(2, WireType.Bit64).double(message.amount);
        /* bool taxable = 3; */
        if (message.taxable !== false)
            writer.tag(3, WireType.Varint).bool(message.taxable);
        /* int32 discount_type = 4; */
        if (message.discountType !== 0)
            writer.tag(4, WireType.Varint).int32(message.discountType);
        /* double rate = 5; */
        if (message.rate !== 0)
            writer.tag(5, WireType.Bit64).double(message.rate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.FanBuilderUseCouponRequest.CouponDetail
 */
export const FanBuilderUseCouponRequest_CouponDetail = new FanBuilderUseCouponRequest_CouponDetail$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FanBuilderUseCouponResponse$Type extends MessageType<FanBuilderUseCouponResponse> {
    constructor() {
        super("rd.integrations.FanBuilderUseCouponResponse", [
            { no: 1, name: "error_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "diagnostic_information", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "token_expired_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "coupon_details", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FanBuilderUseCouponResponse_CouponDetail }
        ]);
    }
    create(value?: PartialMessage<FanBuilderUseCouponResponse>): FanBuilderUseCouponResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.errorFlag = "";
        message.errorMessage = "";
        message.diagnosticInformation = "";
        message.tokenExpiredFlag = "";
        message.couponDetails = [];
        if (value !== undefined)
            reflectionMergePartial<FanBuilderUseCouponResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FanBuilderUseCouponResponse): FanBuilderUseCouponResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string error_flag */ 1:
                    message.errorFlag = reader.string();
                    break;
                case /* string error_message */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* string diagnostic_information */ 3:
                    message.diagnosticInformation = reader.string();
                    break;
                case /* string token_expired_flag */ 4:
                    message.tokenExpiredFlag = reader.string();
                    break;
                case /* repeated rd.integrations.FanBuilderUseCouponResponse.CouponDetail coupon_details */ 5:
                    message.couponDetails.push(FanBuilderUseCouponResponse_CouponDetail.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FanBuilderUseCouponResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string error_flag = 1; */
        if (message.errorFlag !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.errorFlag);
        /* string error_message = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* string diagnostic_information = 3; */
        if (message.diagnosticInformation !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.diagnosticInformation);
        /* string token_expired_flag = 4; */
        if (message.tokenExpiredFlag !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tokenExpiredFlag);
        /* repeated rd.integrations.FanBuilderUseCouponResponse.CouponDetail coupon_details = 5; */
        for (let i = 0; i < message.couponDetails.length; i++)
            FanBuilderUseCouponResponse_CouponDetail.internalBinaryWrite(message.couponDetails[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.FanBuilderUseCouponResponse
 */
export const FanBuilderUseCouponResponse = new FanBuilderUseCouponResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FanBuilderUseCouponResponse_CouponDetail$Type extends MessageType<FanBuilderUseCouponResponse_CouponDetail> {
    constructor() {
        super("rd.integrations.FanBuilderUseCouponResponse.CouponDetail", [
            { no: 1, name: "coupon_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FanBuilderUseCouponResponse_CouponDetail>): FanBuilderUseCouponResponse_CouponDetail {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.couponCode = "";
        message.valid = false;
        message.message = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<FanBuilderUseCouponResponse_CouponDetail>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FanBuilderUseCouponResponse_CouponDetail): FanBuilderUseCouponResponse_CouponDetail {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string coupon_code */ 1:
                    message.couponCode = reader.string();
                    break;
                case /* bool valid */ 2:
                    message.valid = reader.bool();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FanBuilderUseCouponResponse_CouponDetail, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string coupon_code = 1; */
        if (message.couponCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.couponCode);
        /* bool valid = 2; */
        if (message.valid !== false)
            writer.tag(2, WireType.Varint).bool(message.valid);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.FanBuilderUseCouponResponse.CouponDetail
 */
export const FanBuilderUseCouponResponse_CouponDetail = new FanBuilderUseCouponResponse_CouponDetail$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FanBuilderUseCouponLog$Type extends MessageType<FanBuilderUseCouponLog> {
    constructor() {
        super("rd.integrations.FanBuilderUseCouponLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "message_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "system_store_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "system_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "request", kind: "message", T: () => FanBuilderUseCouponRequest },
            { no: 8, name: "response", kind: "message", T: () => FanBuilderUseCouponResponse },
            { no: 10, name: "terminal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "company_id", kind: "message", T: () => UUID },
            { no: 12, name: "sale_id", kind: "message", T: () => UUID },
            { no: 13, name: "status", kind: "enum", T: () => ["rd.integrations.FanBuilderUseCouponLog.Status", FanBuilderUseCouponLog_Status, "STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<FanBuilderUseCouponLog>): FanBuilderUseCouponLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.messageId = "";
        message.systemStoreId = "";
        message.systemCustomerId = "";
        message.terminalId = "";
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<FanBuilderUseCouponLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FanBuilderUseCouponLog): FanBuilderUseCouponLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string message_id */ 4:
                    message.messageId = reader.string();
                    break;
                case /* string system_store_id */ 5:
                    message.systemStoreId = reader.string();
                    break;
                case /* string system_customer_id */ 6:
                    message.systemCustomerId = reader.string();
                    break;
                case /* rd.integrations.FanBuilderUseCouponRequest request */ 7:
                    message.request = FanBuilderUseCouponRequest.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                case /* rd.integrations.FanBuilderUseCouponResponse response */ 8:
                    message.response = FanBuilderUseCouponResponse.internalBinaryRead(reader, reader.uint32(), options, message.response);
                    break;
                case /* string terminal_id */ 10:
                    message.terminalId = reader.string();
                    break;
                case /* rd.proto.uuid.UUID company_id */ 11:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 12:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.integrations.FanBuilderUseCouponLog.Status status */ 13:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FanBuilderUseCouponLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string message_id = 4; */
        if (message.messageId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.messageId);
        /* string system_store_id = 5; */
        if (message.systemStoreId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.systemStoreId);
        /* string system_customer_id = 6; */
        if (message.systemCustomerId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.systemCustomerId);
        /* rd.integrations.FanBuilderUseCouponRequest request = 7; */
        if (message.request)
            FanBuilderUseCouponRequest.internalBinaryWrite(message.request, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.integrations.FanBuilderUseCouponResponse response = 8; */
        if (message.response)
            FanBuilderUseCouponResponse.internalBinaryWrite(message.response, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string terminal_id = 10; */
        if (message.terminalId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.terminalId);
        /* rd.proto.uuid.UUID company_id = 11; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 12; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.integrations.FanBuilderUseCouponLog.Status status = 13; */
        if (message.status !== 0)
            writer.tag(13, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.FanBuilderUseCouponLog
 */
export const FanBuilderUseCouponLog = new FanBuilderUseCouponLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FanBuilderTransactionRequest$Type extends MessageType<FanBuilderTransactionRequest> {
    constructor() {
        super("rd.integrations.FanBuilderTransactionRequest", [
            { no: 1, name: "transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "transaction_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reference", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "customer", kind: "message", T: () => FanBuilderCustomer },
            { no: 5, name: "subtotal", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "total_taxable", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "total_non_taxable", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "total_sales_tax", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "item_details", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FanBuilderTransactionRequest_Item },
            { no: 11, name: "created_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "receipt_details", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 13, name: "card_tokens", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<FanBuilderTransactionRequest>): FanBuilderTransactionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactionId = "";
        message.transactionDate = "";
        message.reference = "";
        message.subtotal = 0;
        message.totalTaxable = 0;
        message.totalNonTaxable = 0;
        message.totalSalesTax = 0;
        message.total = 0;
        message.itemDetails = [];
        message.createdBy = "";
        message.receiptDetails = new Uint8Array(0);
        message.cardTokens = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<FanBuilderTransactionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FanBuilderTransactionRequest): FanBuilderTransactionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string transaction_id */ 1:
                    message.transactionId = reader.string();
                    break;
                case /* string transaction_date */ 2:
                    message.transactionDate = reader.string();
                    break;
                case /* string reference */ 3:
                    message.reference = reader.string();
                    break;
                case /* rd.integrations.FanBuilderCustomer customer */ 4:
                    message.customer = FanBuilderCustomer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* double subtotal */ 5:
                    message.subtotal = reader.double();
                    break;
                case /* double total_taxable */ 6:
                    message.totalTaxable = reader.double();
                    break;
                case /* double total_non_taxable */ 7:
                    message.totalNonTaxable = reader.double();
                    break;
                case /* double total_sales_tax */ 8:
                    message.totalSalesTax = reader.double();
                    break;
                case /* double total */ 9:
                    message.total = reader.double();
                    break;
                case /* repeated rd.integrations.FanBuilderTransactionRequest.Item item_details */ 10:
                    message.itemDetails.push(FanBuilderTransactionRequest_Item.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string created_by */ 11:
                    message.createdBy = reader.string();
                    break;
                case /* bytes receipt_details */ 12:
                    message.receiptDetails = reader.bytes();
                    break;
                case /* bytes card_tokens */ 13:
                    message.cardTokens = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FanBuilderTransactionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string transaction_id = 1; */
        if (message.transactionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.transactionId);
        /* string transaction_date = 2; */
        if (message.transactionDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.transactionDate);
        /* string reference = 3; */
        if (message.reference !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reference);
        /* rd.integrations.FanBuilderCustomer customer = 4; */
        if (message.customer)
            FanBuilderCustomer.internalBinaryWrite(message.customer, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* double subtotal = 5; */
        if (message.subtotal !== 0)
            writer.tag(5, WireType.Bit64).double(message.subtotal);
        /* double total_taxable = 6; */
        if (message.totalTaxable !== 0)
            writer.tag(6, WireType.Bit64).double(message.totalTaxable);
        /* double total_non_taxable = 7; */
        if (message.totalNonTaxable !== 0)
            writer.tag(7, WireType.Bit64).double(message.totalNonTaxable);
        /* double total_sales_tax = 8; */
        if (message.totalSalesTax !== 0)
            writer.tag(8, WireType.Bit64).double(message.totalSalesTax);
        /* double total = 9; */
        if (message.total !== 0)
            writer.tag(9, WireType.Bit64).double(message.total);
        /* repeated rd.integrations.FanBuilderTransactionRequest.Item item_details = 10; */
        for (let i = 0; i < message.itemDetails.length; i++)
            FanBuilderTransactionRequest_Item.internalBinaryWrite(message.itemDetails[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string created_by = 11; */
        if (message.createdBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.createdBy);
        /* bytes receipt_details = 12; */
        if (message.receiptDetails.length)
            writer.tag(12, WireType.LengthDelimited).bytes(message.receiptDetails);
        /* bytes card_tokens = 13; */
        if (message.cardTokens.length)
            writer.tag(13, WireType.LengthDelimited).bytes(message.cardTokens);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.FanBuilderTransactionRequest
 */
export const FanBuilderTransactionRequest = new FanBuilderTransactionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FanBuilderTransactionRequest_Item$Type extends MessageType<FanBuilderTransactionRequest_Item> {
    constructor() {
        super("rd.integrations.FanBuilderTransactionRequest.Item", [
            { no: 1, name: "line_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "item_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "quantity", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "extension", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "quantity_unit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "price_unit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "codes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "department", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "upc", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FanBuilderTransactionRequest_Item>): FanBuilderTransactionRequest_Item {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.lineNumber = 0;
        message.itemNumber = "";
        message.description = "";
        message.quantity = 0;
        message.price = 0;
        message.extension = 0;
        message.quantityUnit = "";
        message.priceUnit = "";
        message.codes = "";
        message.department = "";
        message.upc = "";
        if (value !== undefined)
            reflectionMergePartial<FanBuilderTransactionRequest_Item>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FanBuilderTransactionRequest_Item): FanBuilderTransactionRequest_Item {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 line_number */ 1:
                    message.lineNumber = reader.int32();
                    break;
                case /* string item_number */ 2:
                    message.itemNumber = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* double quantity */ 4:
                    message.quantity = reader.double();
                    break;
                case /* double price */ 5:
                    message.price = reader.double();
                    break;
                case /* double extension */ 6:
                    message.extension = reader.double();
                    break;
                case /* string quantity_unit */ 7:
                    message.quantityUnit = reader.string();
                    break;
                case /* string price_unit */ 8:
                    message.priceUnit = reader.string();
                    break;
                case /* string codes */ 9:
                    message.codes = reader.string();
                    break;
                case /* string department */ 10:
                    message.department = reader.string();
                    break;
                case /* string upc */ 11:
                    message.upc = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FanBuilderTransactionRequest_Item, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 line_number = 1; */
        if (message.lineNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.lineNumber);
        /* string item_number = 2; */
        if (message.itemNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.itemNumber);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* double quantity = 4; */
        if (message.quantity !== 0)
            writer.tag(4, WireType.Bit64).double(message.quantity);
        /* double price = 5; */
        if (message.price !== 0)
            writer.tag(5, WireType.Bit64).double(message.price);
        /* double extension = 6; */
        if (message.extension !== 0)
            writer.tag(6, WireType.Bit64).double(message.extension);
        /* string quantity_unit = 7; */
        if (message.quantityUnit !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.quantityUnit);
        /* string price_unit = 8; */
        if (message.priceUnit !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.priceUnit);
        /* string codes = 9; */
        if (message.codes !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.codes);
        /* string department = 10; */
        if (message.department !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.department);
        /* string upc = 11; */
        if (message.upc !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.upc);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.FanBuilderTransactionRequest.Item
 */
export const FanBuilderTransactionRequest_Item = new FanBuilderTransactionRequest_Item$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FanBuilderTransactionResponse$Type extends MessageType<FanBuilderTransactionResponse> {
    constructor() {
        super("rd.integrations.FanBuilderTransactionResponse", [
            { no: 1, name: "error_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "diagnostic_information", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "token_expired_flag", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FanBuilderTransactionResponse>): FanBuilderTransactionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.errorFlag = "";
        message.errorMessage = "";
        message.diagnosticInformation = "";
        message.tokenExpiredFlag = "";
        if (value !== undefined)
            reflectionMergePartial<FanBuilderTransactionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FanBuilderTransactionResponse): FanBuilderTransactionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string error_flag */ 1:
                    message.errorFlag = reader.string();
                    break;
                case /* string error_message */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* string diagnostic_information */ 3:
                    message.diagnosticInformation = reader.string();
                    break;
                case /* string token_expired_flag */ 4:
                    message.tokenExpiredFlag = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FanBuilderTransactionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string error_flag = 1; */
        if (message.errorFlag !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.errorFlag);
        /* string error_message = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* string diagnostic_information = 3; */
        if (message.diagnosticInformation !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.diagnosticInformation);
        /* string token_expired_flag = 4; */
        if (message.tokenExpiredFlag !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tokenExpiredFlag);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.FanBuilderTransactionResponse
 */
export const FanBuilderTransactionResponse = new FanBuilderTransactionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FanBuilderTransactionLog$Type extends MessageType<FanBuilderTransactionLog> {
    constructor() {
        super("rd.integrations.FanBuilderTransactionLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "message_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "system_store_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "terminal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "sale_id", kind: "message", T: () => UUID },
            { no: 8, name: "company_id", kind: "message", T: () => UUID },
            { no: 9, name: "request", kind: "message", T: () => FanBuilderTransactionRequest },
            { no: 10, name: "response", kind: "message", T: () => FanBuilderTransactionResponse },
            { no: 11, name: "is_delivered", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<FanBuilderTransactionLog>): FanBuilderTransactionLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.messageId = "";
        message.systemStoreId = "";
        message.terminalId = "";
        message.isDelivered = false;
        if (value !== undefined)
            reflectionMergePartial<FanBuilderTransactionLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FanBuilderTransactionLog): FanBuilderTransactionLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string message_id */ 4:
                    message.messageId = reader.string();
                    break;
                case /* string system_store_id */ 5:
                    message.systemStoreId = reader.string();
                    break;
                case /* string terminal_id */ 6:
                    message.terminalId = reader.string();
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 7:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 8:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.integrations.FanBuilderTransactionRequest request */ 9:
                    message.request = FanBuilderTransactionRequest.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                case /* rd.integrations.FanBuilderTransactionResponse response */ 10:
                    message.response = FanBuilderTransactionResponse.internalBinaryRead(reader, reader.uint32(), options, message.response);
                    break;
                case /* bool is_delivered */ 11:
                    message.isDelivered = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FanBuilderTransactionLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string message_id = 4; */
        if (message.messageId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.messageId);
        /* string system_store_id = 5; */
        if (message.systemStoreId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.systemStoreId);
        /* string terminal_id = 6; */
        if (message.terminalId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.terminalId);
        /* rd.proto.uuid.UUID sale_id = 7; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 8; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.integrations.FanBuilderTransactionRequest request = 9; */
        if (message.request)
            FanBuilderTransactionRequest.internalBinaryWrite(message.request, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.integrations.FanBuilderTransactionResponse response = 10; */
        if (message.response)
            FanBuilderTransactionResponse.internalBinaryWrite(message.response, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* bool is_delivered = 11; */
        if (message.isDelivered !== false)
            writer.tag(11, WireType.Varint).bool(message.isDelivered);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.FanBuilderTransactionLog
 */
export const FanBuilderTransactionLog = new FanBuilderTransactionLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RewardProgramCredentials$Type extends MessageType<RewardProgramCredentials> {
    constructor() {
        super("rd.integrations.RewardProgramCredentials", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "integration_vendor", kind: "enum", T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] },
            { no: 6, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "password", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 8, name: "auth_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "auth_token_acquired_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<RewardProgramCredentials>): RewardProgramCredentials {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.integrationVendor = 0;
        message.username = "";
        message.password = new Uint8Array(0);
        message.authToken = "";
        if (value !== undefined)
            reflectionMergePartial<RewardProgramCredentials>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RewardProgramCredentials): RewardProgramCredentials {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.integration_vendor.IntegrationVendor integration_vendor */ 5:
                    message.integrationVendor = reader.int32();
                    break;
                case /* string username */ 6:
                    message.username = reader.string();
                    break;
                case /* bytes password */ 7:
                    message.password = reader.bytes();
                    break;
                case /* string auth_token */ 8:
                    message.authToken = reader.string();
                    break;
                case /* google.protobuf.Timestamp auth_token_acquired_at */ 9:
                    message.authTokenAcquiredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.authTokenAcquiredAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RewardProgramCredentials, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.integration_vendor.IntegrationVendor integration_vendor = 5; */
        if (message.integrationVendor !== 0)
            writer.tag(5, WireType.Varint).int32(message.integrationVendor);
        /* string username = 6; */
        if (message.username !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.username);
        /* bytes password = 7; */
        if (message.password.length)
            writer.tag(7, WireType.LengthDelimited).bytes(message.password);
        /* string auth_token = 8; */
        if (message.authToken !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.authToken);
        /* google.protobuf.Timestamp auth_token_acquired_at = 9; */
        if (message.authTokenAcquiredAt)
            Timestamp.internalBinaryWrite(message.authTokenAcquiredAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.RewardProgramCredentials
 */
export const RewardProgramCredentials = new RewardProgramCredentials$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RetailInventorySnapshot$Type extends MessageType<RetailInventorySnapshot> {
    constructor() {
        super("rd.integrations.RetailInventorySnapshot", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "location_id", kind: "message", T: () => UUID },
            { no: 6, name: "account_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "product_id", kind: "message", T: () => UUID },
            { no: 8, name: "integration_vendor", kind: "enum", T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] },
            { no: 9, name: "sku", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "vendor_sku_id", kind: "message", T: () => UUID },
            { no: 11, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "on_hand_v2", kind: "message", T: () => Decimal },
            { no: 13, name: "on_order_v2", kind: "message", T: () => Decimal },
            { no: 14, name: "last_sale", kind: "message", T: () => Timestamp },
            { no: 15, name: "retail_price", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<RetailInventorySnapshot>): RetailInventorySnapshot {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountNumber = "";
        message.integrationVendor = 0;
        message.sku = "";
        message.isActive = false;
        if (value !== undefined)
            reflectionMergePartial<RetailInventorySnapshot>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RetailInventorySnapshot): RetailInventorySnapshot {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 5:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string account_number */ 6:
                    message.accountNumber = reader.string();
                    break;
                case /* rd.proto.uuid.UUID product_id */ 7:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.integration_vendor.IntegrationVendor integration_vendor */ 8:
                    message.integrationVendor = reader.int32();
                    break;
                case /* string sku */ 9:
                    message.sku = reader.string();
                    break;
                case /* rd.proto.uuid.UUID vendor_sku_id */ 10:
                    message.vendorSkuId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorSkuId);
                    break;
                case /* bool is_active */ 11:
                    message.isActive = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal on_hand_v2 */ 12:
                    message.onHandV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.onHandV2);
                    break;
                case /* rd.proto.decimal.Decimal on_order_v2 */ 13:
                    message.onOrderV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.onOrderV2);
                    break;
                case /* google.protobuf.Timestamp last_sale */ 14:
                    message.lastSale = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastSale);
                    break;
                case /* rd.proto.money.Money retail_price */ 15:
                    message.retailPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.retailPrice);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RetailInventorySnapshot, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 5; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string account_number = 6; */
        if (message.accountNumber !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.accountNumber);
        /* rd.proto.uuid.UUID product_id = 7; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.integration_vendor.IntegrationVendor integration_vendor = 8; */
        if (message.integrationVendor !== 0)
            writer.tag(8, WireType.Varint).int32(message.integrationVendor);
        /* string sku = 9; */
        if (message.sku !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.sku);
        /* rd.proto.uuid.UUID vendor_sku_id = 10; */
        if (message.vendorSkuId)
            UUID.internalBinaryWrite(message.vendorSkuId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active = 11; */
        if (message.isActive !== false)
            writer.tag(11, WireType.Varint).bool(message.isActive);
        /* rd.proto.decimal.Decimal on_hand_v2 = 12; */
        if (message.onHandV2)
            Decimal.internalBinaryWrite(message.onHandV2, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal on_order_v2 = 13; */
        if (message.onOrderV2)
            Decimal.internalBinaryWrite(message.onOrderV2, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_sale = 14; */
        if (message.lastSale)
            Timestamp.internalBinaryWrite(message.lastSale, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money retail_price = 15; */
        if (message.retailPrice)
            Money.internalBinaryWrite(message.retailPrice, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.RetailInventorySnapshot
 */
export const RetailInventorySnapshot = new RetailInventorySnapshot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocationSettingsOption$Type extends MessageType<LocationSettingsOption> {
    constructor() {
        super("rd.integrations.LocationSettingsOption", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<LocationSettingsOption>): LocationSettingsOption {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.label = "";
        if (value !== undefined)
            reflectionMergePartial<LocationSettingsOption>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LocationSettingsOption): LocationSettingsOption {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LocationSettingsOption, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.integrations.LocationSettingsOption
 */
export const LocationSettingsOption = new LocationSettingsOption$Type();
